// Helpers globais para evitar requisições duplicadas para endpoints ShopifyData
(function() {
  const filteredDataCache = {};
  const metaobjectsCache = {};
  const productsCache = {};
  const metafieldsCache = {};

  window.fetchFilteredDataOnce = async function(termId, campusId) {
    const key = `${campusId}|${termId}`;

    if (filteredDataCache[key]) {
      return filteredDataCache[key];
    }

    const proxyPath = '/apps/shopifyData/getFilteredData';
    const url = `${proxyPath}?campus_entity_id=${campusId}&term_id=${termId}`;

    const promise = (async () => {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (!result.success) {
        throw new Error(result.error || 'Failed to fetch metaobjects');
      }

      return result.data;
    })();

    filteredDataCache[key] = promise;
    return promise;
  };

  window.fetchMetaobjectsOnce = async function(metaobjectType, queryRaw) {
    const query = queryRaw ?? '';
    const key = `${metaobjectType}|${query}`;

    if (metaobjectsCache[key]) {
      return metaobjectsCache[key];
    }

    const proxyPath = '/apps/shopifyData/metaobjects';
    const url = `${proxyPath}?type=${encodeURIComponent(metaobjectType)}&query=${encodeURIComponent(query)}`;

    const promise = (async () => {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (!result.success) {
        throw new Error(result.error || 'Failed to fetch metaobjects');
      }

      const activeMetaobjects = Array.isArray(result.data)
        ? result.data.filter(item => item.status === 'ACTIVE')
        : result.data;

      return activeMetaobjects;
    })();

    metaobjectsCache[key] = promise;
    return promise;
  };

  window.fetchProductsOnce = async function(queryRaw) {
    const query = queryRaw ?? '';
    const key = query;

    if (productsCache[key]) {
      return productsCache[key];
    }

    const proxyPath = '/apps/shopifyData/products';
    const url = `${proxyPath}?query=${encodeURIComponent(query)}`;

    const promise = (async () => {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (!result.success) {
        throw new Error(result.error || 'Failed to fetch products');
      }

      return result.products;
    })();

    productsCache[key] = promise;
    return promise;
  };

  window.fetchMetafieldsOnce = async function(variantId) {
    const key = String(variantId);

    if (metafieldsCache[key]) {
      return metafieldsCache[key];
    }

    const proxyPath = '/apps/shopifyData/getMetafields';
    const url = `${proxyPath}?query=gid://shopify/ProductVariant/${encodeURIComponent(variantId)}`;

    const promise = (async () => {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (!result.success) {
        throw new Error(result.error || 'Failed to fetch Metafields');
      }

      return result.data;
    })();

    metafieldsCache[key] = promise;
    return promise;
  };
})();

/** @param {HTMLOptionElement | undefined} opt */
function cmrpOptionLabelForMatch(opt) {
  if (!opt) return '';
  if (
    typeof window !== 'undefined' &&
    typeof window.cmrpOptionFullLabel === 'function'
  ) {
    return window.cmrpOptionFullLabel(opt);
  }
  return String(opt.text ?? '').trim();
}

/**
 * Course-builder DDCS `<select>` ids use `cmrpId(base, 'cb')` (e.g. `division-cb`) when dual-form.
 */
function cmrpCbCourseLineSelectId(base) {
  if (typeof window !== 'undefined' && typeof window.cmrpId === 'function') {
    return window.cmrpId(base, 'cb');
  }
  return base;
}

/** URLSearchParams + our own encoding can leave values that break `decodeURIComponent`. */
function cmrpSafeDecodeURIComponent(value) {
  if (value == null) return '';
  const s = String(value);
  if (!s) return '';
  try {
    return decodeURIComponent(s.replace(/\+/g, ' '));
  } catch {
    return s;
  }
}

function cmrpNormalizeFlowForStorage(rawFlow) {
  const flow = String(rawFlow || '').trim().toLowerCase();
  if (flow === 'student-id' || flow === 'course-builder' || flow === 'sso') return flow;
  return '';
}

function cmrpPersistFlowFromUrlState(flow) {
  const normalized = cmrpNormalizeFlowForStorage(flow);
  if (!normalized) return;
  if (typeof window.cmrpPersistFlow === 'function') {
    window.cmrpPersistFlow(normalized);
    return;
  }
  try {
    sessionStorage.setItem('cmrp_flow', normalized);
  } catch (e) {
    /* ignore */
  }
}

/** FM-2391: decode HTML entities in DDCS labels (optional: window.decodeCmrpHtmlEntities from sidebar). */
function decodeCmrpLabel(text) {
  if (typeof window !== 'undefined' && typeof window.decodeCmrpHtmlEntities === 'function') {
    return window.decodeCmrpHtmlEntities(text);
  }
  if (text == null || text === '') return text ?? '';
  const str = String(text);
  if (!str.includes('&')) return str;
  const ta = document.createElement('textarea');
  ta.innerHTML = str;
  return ta.value;
}

class URLStateManager {
  /** @param {string} [search] */
  static hasDeepLinkCourseParamsInSearch(search) {
    const p = new URLSearchParams(search ?? '');
    return Boolean(
      p.get('sectionDisplayName') ||
        p.get('courseDisplayName') ||
        p.get('courseRefId')
    );
  }

  constructor(config = {}) {
    // @ts-ignore
    this.selectedFilters = config.selectedFilters || [];
    // @ts-ignore
    this.ddcsSection = config.ddcsSection || [];
    // @ts-ignore
    this.ddcsCampusEntity = config.ddcsCampusEntity || [];
    // @ts-ignore
    this.ddcsTerm = config.ddcsTerm || [];
    // @ts-ignore
    this.ddcsCampusDepartment = config.ddcsCampusDepartment || [];
    // @ts-ignore
    this.ddcsCourse = config.ddcsCourse || [];
    // @ts-ignore
    this.addLabelCallback = config.addLabelCallback || (() => {});
    // @ts-ignore
    this.refreshProductsCallback = config.refreshProductsCallback || (() => {});

    this.URL_PARAMS = {
      SHOP_BY: 'shopBy',
      TERM_ID: 'termId',
      DIVISION_DISPLAY_NAME: 'divisionDisplayName',
      DEPARTMENT_DISPLAY_NAME: 'departmentDisplayName',
      COURSE_DISPLAY_NAME: 'courseDisplayName',
      COURSE_REF_ID: 'courseRefId',
      SECTION_DISPLAY_NAME: 'sectionDisplayName',
    };

    this.urlParamsToRestore = null;
    /** Deep-link arrays captured once on init; sidebar may call `setURLSearchParams` before restore. */
    this._initialUrlRestoreSnapshot = null;
    /** While true, skip stripping CMRP params from the URL when filters are still empty (URL restore / sidebar init). */
    this._deferEmptyFilterUrlStrip = false;
    /** True while attemptURLRestoration / restoreFormStateFromURL is in flight. */
    this._isUrlRestoreInProgress = false;
    this._urlRestoreSidebarRetries = 0;
    /** True while the inactivity modal is up; URL restore waits for Keep. */
    this._urlRestoreAwaitingExpiryKeep = false;
    /** Prevents double restore if Keep races with initialize(). */
    this._restoreFromLocationStarted = false;
    /** Stays true until form cascade finishRestore (longer than attemptURLRestoration). */
    this._isUrlFormCascadePending = false;
    /** shopBy from the landing URL (e.g. discoverview) preserved across URL sync. */
    this._preservedShopByFromUrl = '';

    // Bind methods to preserve context
    this.parseURLParameters = this.parseURLParameters.bind(this);
    this.setURLSearchParams = this.setURLSearchParams.bind(this);
    this.restoreFormStateFromURL = this.restoreFormStateFromURL.bind(this);
    this.buildFiltersFromURLParams = this.buildFiltersFromURLParams.bind(this);
    this.findMatchingEntities = this.findMatchingEntities.bind(this);
    this.prefetchUrlRestoreLookups = this.prefetchUrlRestoreLookups.bind(this);
    this.createFilterObject = this.createFilterObject.bind(this);
    this.restoreDropdownsAndUI = this.restoreDropdownsAndUI.bind(this);
    this.setCampusDropdown = this.setCampusDropdown.bind(this);
    this.setTermDropdown = this.setTermDropdown.bind(this);
    this.populateTermsForCampus = this.populateTermsForCampus.bind(this);
    this.restoreAllFormFieldsFromURL =
      this.restoreAllFormFieldsFromURL.bind(this);
    this.restoreFieldsCascade = this.restoreFieldsCascade.bind(this);
    this.continueWithDepartment = this.continueWithDepartment.bind(this);
    this.continueWithCourse = this.continueWithCourse.bind(this);
    this.continueWithSection = this.continueWithSection.bind(this);
    this.finishRestore = this.finishRestore.bind(this);
    this.triggerDepartmentCascadeForRestore =
      this.triggerDepartmentCascadeForRestore.bind(this);
    this.attemptURLRestoration = this.attemptURLRestoration.bind(this);
    this.resumeRestoreAfterExpiryKeep =
      this.resumeRestoreAfterExpiryKeep.bind(this);
    this.releaseInitialLoadingHold = this.releaseInitialLoadingHold.bind(this);
    this.clearExistingFilters = this.clearExistingFilters.bind(this);
    this.cmrpUrlRestoreCampusTermSelect =
      this.cmrpUrlRestoreCampusTermSelect.bind(this);
    /** @type {boolean} */
    this._cmrpUrlRestoreTargetStudentIdForm = false;
  }

  isUrlRestorePending() {
    return Boolean(
      this._deferEmptyFilterUrlStrip ||
        this._isUrlRestoreInProgress ||
        this._isUrlFormCascadePending ||
        this._urlRestoreAwaitingExpiryKeep ||
        (typeof window.CmrpSessionSnapshot?.isExpiryPromptPending ===
          'function' &&
          window.CmrpSessionSnapshot.isExpiryPromptPending())
    );
  }

  /**
   * Campus/term `<select>` used while restoring from URL: student-id row when dual CMRP docks
   * results under the student-id anchor; otherwise course-builder / legacy ids.
   * @param {'campus'|'term'} inner
   * @returns {HTMLElement | null}
   */
  cmrpUrlRestoreCampusTermSelect(inner) {
    if (
      this._cmrpUrlRestoreTargetStudentIdForm &&
      typeof window.cmrpId === 'function'
    ) {
      const panel = document.getElementById('filters-section');
      const suf = (panel?.dataset?.cmrpSuffixStudentId || 'sid').trim();
      if (!suf) return null;
      const rootId = `campus-term-dropdowns-${suf}`;
      const fieldId = window.cmrpId(inner, 'sid');
      return document.querySelector(`#${rootId} #${fieldId}`);
    }
    if (typeof window.cmrpCourseBuilderCampusTermEl === 'function') {
      return window.cmrpCourseBuilderCampusTermEl(inner);
    }
    if (typeof window.cmrpQueryDesktopCampusTerm === 'function') {
      return window.cmrpQueryDesktopCampusTerm(inner);
    }
    return document.querySelector(`#campus-term-dropdowns #${inner}`);
  }

  /**
   * Align pipe-separated termId values to course-line count.
   * One termId → reuse for every line (legacy). Multiple → positional (termId=A|B).
   * @param {string[]} parts
   * @param {number} lineCount
   * @returns {string[]}
   */
  alignPipeValuesToLineCount(parts, lineCount) {
    if (!Array.isArray(parts) || parts.length === 0 || lineCount <= 0) {
      return [];
    }
    if (parts.length === 1) {
      return Array(lineCount).fill(parts[0]);
    }
    const out = parts.slice(0, lineCount);
    while (out.length < lineCount) {
      out.push(parts[parts.length - 1] ?? '');
    }
    return out;
  }

  /**
   * Normalize a pipe-separated URL param (%7C / |) into trimmed non-empty parts.
   * @param {string|null|undefined} raw
   * @returns {string[]}
   */
  splitPipeUrlParam(raw) {
    if (raw == null || raw === '') return [];
    const decoded = cmrpSafeDecodeURIComponent(String(raw))
      .replaceAll('%7C', '|')
      .replaceAll('%7c', '|');
    return decoded
      .split('|')
      .map(part => String(part).trim())
      .filter(part => part !== '');
  }

  /**
   * Resolve store number for a course-line index from merfnbr / bookstoreId.
   * Supports multi-value URLs: bookstoreId=0772|1395 (positional with termId).
   * @param {number} [lineIndex=0]
   * @returns {string}
   */
  resolveStoreNumberForLine(lineIndex = 0) {
    const urlParams = new URLSearchParams(window.location.search);
    const parts = this.splitPipeUrlParam(
      urlParams.get('merfnbr') || urlParams.get('bookstoreId'),
    );
    if (parts.length === 0) return '';
    if (parts.length === 1) return parts[0];
    const idx = Number.isFinite(lineIndex) && lineIndex >= 0 ? lineIndex : 0;
    return parts[idx] || parts[0] || '';
  }

  /**
   * @param {boolean} [persistRestoreSnapshot=false] - When true (initial page load only), store parsed
   *   course-line params on `urlParamsToRestore` for one-time form restoration. When false, read the
   *   current URL without updating that snapshot so later URL updates do not re-hydrate the builder row.
   */
  parseURLParameters(persistRestoreSnapshot = false) {
    const stripped = new URLSearchParams(window.location.search);
    const landingShopBy = stripped.get(this.URL_PARAMS.SHOP_BY);
    if (landingShopBy) {
      this._preservedShopByFromUrl = landingShopBy;
    }
    if (stripped.has('student_id')) {
      stripped.delete('student_id');
      const qs = stripped.toString();
      window.history.replaceState(
        {},
        '',
        qs ? `${window.location.pathname}?${qs}` : window.location.pathname
      );
    }
    const urlParams = new URLSearchParams(window.location.search);
    // URLSearchParams already decodes %7C → |. Support accidental double-encoding too.
    const rawTermIdFromUrl = (urlParams.get(this.URL_PARAMS.TERM_ID) || '')
      .replaceAll('%7C', '|')
      .replaceAll('%7c', '|')
      .trim() || null;

    const params = {
      // @ts-ignore
      shopBy: urlParams.get(this.URL_PARAMS.SHOP_BY),
      // @ts-ignore
      termId: rawTermIdFromUrl?.toLowerCase().replace(/\s+/g, '') ?? null,
      // @ts-ignore
      rawTermId: rawTermIdFromUrl,
      // @ts-ignore
      divisionDisplayName: urlParams.get(this.URL_PARAMS.DIVISION_DISPLAY_NAME),
      // @ts-ignore
      departmentDisplayName: urlParams.get(
        this.URL_PARAMS.DEPARTMENT_DISPLAY_NAME
      ),
      // @ts-ignore
      courseDisplayName: urlParams.get(this.URL_PARAMS.COURSE_DISPLAY_NAME),
      // @ts-ignore
      courseRefId: urlParams.get(this.URL_PARAMS.COURSE_REF_ID),
      // @ts-ignore
      sectionDisplayName: urlParams.get(this.URL_PARAMS.SECTION_DISPLAY_NAME),
      // @ts-ignore
      
    };

    // Multi-course deep links: pipe-separated display names (e.g. C0311|C0411|C0511).
    // Multi-term / parent+child store: termId=A|B aligned to line count (legacy single termId repeats).
    const divisions = params.divisionDisplayName
      ? params.divisionDisplayName.split('|')
      : [];
    const departments = params.departmentDisplayName
      ? params.departmentDisplayName.split('|')
      : [];
    const courses = params.courseDisplayName
      ? params.courseDisplayName.split('|')
      : [];
    const courseRefIds = params.courseRefId
      ? params.courseRefId.split('|')
      : [];
    const sections = params.sectionDisplayName
      ? params.sectionDisplayName.split('|')
      : [];

    const termIdParts = params.termId ? params.termId.split('|') : [];
    const rawTermIdParts = params.rawTermId ? params.rawTermId.split('|') : [];
    const lineCount = Math.max(
      sections.length,
      courseRefIds.length,
      divisions.length,
      departments.length,
      courses.length,
      termIdParts.length > 1 ? termIdParts.length : 0,
    );

    const parsed = {
      rawTermId: params.rawTermId,
      rawTermIds: this.alignPipeValuesToLineCount(rawTermIdParts, lineCount || termIdParts.length),
      termsIds: this.alignPipeValuesToLineCount(termIdParts, lineCount || termIdParts.length),
      divisions,
      departments,
      courses,
      courseRefIds,
      sections,
    };
    if (persistRestoreSnapshot) {
      this.urlParamsToRestore = parsed;
    }
    return parsed;
  }

  setURLSearchParams(options = {}) {
    const studentIdField = document.getElementById(
      typeof window.cmrpId === 'function'
        ? window.cmrpId('student-id', 'sid')
        : 'student-id',
    );
    const mobileStudentIdInput = document.getElementById(
      'mobile-student-id-input'
    );
    // @ts-ignore
    const typedStudentId = (
      studentIdField?.value ||
      mobileStudentIdInput?.value ||
      ''
    ).trim();

    const dualCmrp =
      document.getElementById('filters-section')?.dataset?.cmrpStudentIdActive ===
      'true';
    const allFiltersFromStudentId =
      this.selectedFilters.length > 0 &&
      this.selectedFilters.every(f => f && f.fromStudentId === true);
    let forStudentIdFlow;
    if (dualCmrp && this.selectedFilters.length > 0) {
      forStudentIdFlow = allFiltersFromStudentId;
    } else if (allFiltersFromStudentId) {
      // SID session restore stamps fromStudentId; keep shopBy=studentid even if the
      // typed ID field is empty (homepage card may have ended the SID session).
      forStudentIdFlow = true;
    } else {
      forStudentIdFlow = Boolean(typedStudentId);
    }

    const paramStrings = this.buildParameterStrings();
    // Always sync the address bar: when there are no courses, strip shop/course params
    // (previously we returned early and left stale deep links like departmentDisplayName=…).
    this.updateURLWithParameters(paramStrings, forStudentIdFlow, options);
  }

  clearURL() {
    const params = new URLSearchParams(window.location.search);
    
    Object.values(this.URL_PARAMS).forEach(param => params.delete(param));

    const newUrl = params.toString()
      ? `${window.location.pathname}?${params}`
      : window.location.pathname;

    window.history.replaceState({}, '', newUrl);
  }

  /**
   * Campus DDCS flags for the campus on the current filter set (URL shaping only).
   * @returns {{ is_department_used_flag: boolean, is_division_used_flag: boolean } | null}
   */
  _campusFlagsForSelectedCampus() {
    const campusName = this.selectedFilters[0]?.selectedCampus;
    if (!campusName || !window.courseData?.ddcs_campus_entity) {
      return null;
    }
    const normalize = v =>
      String(v ?? '')
        .toLowerCase()
        .replace(/\s+/g, '');
    const hit = window.courseData.ddcs_campus_entity.find(
      c => normalize(c.name) === normalize(campusName)
    );
    if (!hit) return null;
    return {
      is_department_used_flag: Boolean(hit.is_department_used_flag),
      is_division_used_flag: Boolean(hit.is_division_used_flag),
    };
  }

  /**
   * Store number for a restored / form filter (parent+child bookstoreId pipes).
   * @param {any} filter
   * @returns {string}
   */
  storeNumberForFilter(filter) {
    const fromFilter = String(filter?.store_number || '').trim();
    if (fromFilter) return fromFilter;
    const campusName = String(filter?.selectedCampus || '').trim();
    if (!campusName || !window.courseData?.ddcs_campus_entity) return '';
    const normalize = v =>
      String(v ?? '')
        .toLowerCase()
        .replace(/\s+/g, '');
    const hit = window.courseData.ddcs_campus_entity.find(
      c => normalize(c.name) === normalize(campusName)
    );
    return String(hit?.store_number || '').trim();
  }

  /**
   * Keep bookstoreId / merfnbr aligned with remaining course lines.
   * Single-value params stay (one store for every line). Multi-value params
   * are rebuilt from each filter's store_number.
   * @param {URLSearchParams} params
   */
  syncStoreNumberQueryParam(params) {
    if (!params) return;
    const storeKey = params.has('merfnbr')
      ? 'merfnbr'
      : params.has('bookstoreId')
        ? 'bookstoreId'
        : null;
    if (!storeKey) return;
    const existing = this.splitPipeUrlParam(params.get(storeKey));
    if (existing.length <= 1) return;
    const stores = this.selectedFilters.map(filter =>
      this.storeNumberForFilter(filter)
    );
    if (!stores.some(Boolean)) return;
    const next = stores.join('|');
    if (!next || stores.every(part => !part)) {
      params.delete(storeKey);
    } else {
      params.set(storeKey, next);
    }
  }

  buildParameterStrings() {
    const results = {
      selectedCampus: '',
      selectedTermId: '',
      selectedDivision: '',
      selectedDepartment: '',
      selectedcourse: '',
      selectedsection: '',
      selectedcourseRefId: '',
    };
    // @ts-ignore
    this.selectedFilters.forEach((filterObj, index) => {
      const separator = index === this.selectedFilters.length - 1 ? '' : '|';

      Object.keys(results).forEach(key => {
        if (key === 'selectedcourseRefId') return;
        const value = filterObj[key] || '';
        // Join all selectedTermId values with | (same as other course-line params)
        // so multi-term deep links round-trip correctly.
        results[key] += value + separator;
      });
    });

    const courseRefIds = this.selectedFilters.map(
      filterObj => filterObj.courseRefId || filterObj.selectedcourseRefId || ''
    );
    if (courseRefIds.some(id => id)) {
      results.selectedcourseRefId = courseRefIds.join('|');
    }

    // FM-2542: omit division/department from shareable URL when campus does not use them.
    // Filters still keep those fields for DDCS resolution (student-ID path).
    const campusFlags = this._campusFlagsForSelectedCampus();
    if (campusFlags) {
      if (!campusFlags.is_department_used_flag) {
        results.selectedDepartment = '';
      }
      if (!campusFlags.is_division_used_flag) {
        results.selectedDivision = '';
      }
    }

    return results;
    
  }

  // @ts-ignore
  updateURLWithParameters(paramStrings, forStudentIdFlow = null, options = {}) {
    const params = new URLSearchParams(window.location.search);

    const isStudentIdUrl = Boolean(forStudentIdFlow);

    if (this.selectedFilters.length > 0) {
      const existingShopBy =
        params.get(this.URL_PARAMS.SHOP_BY) || this._preservedShopByFromUrl || '';
      let selectedCampus = isStudentIdUrl ? 'studentid' : 'course';
      if (!isStudentIdUrl) {
        const existingLower = String(existingShopBy).toLowerCase();
        if (
          existingLower.includes('discover') ||
          existingLower === 'courserefid'
        ) {
          selectedCampus = existingShopBy;
        }
      }
      const selectedDivision = paramStrings.selectedDivision;
      const selectedDepartment = paramStrings.selectedDepartment;
      const selectedcourse = paramStrings.selectedcourse;
      const selectedcourseRefId = paramStrings.selectedcourseRefId;
      const selectedsection = paramStrings.selectedsection;
      const selectedTermId = paramStrings.selectedTermId;
      const hadCourseRefId = Boolean(params.get(this.URL_PARAMS.COURSE_REF_ID));
      cmrpPersistFlowFromUrlState(isStudentIdUrl ? 'student-id' : 'course-builder');
      // URLSearchParams encodes on serialize; do not pre-encode or & becomes %2526 in the bar.
      params.set(this.URL_PARAMS.SHOP_BY, selectedCampus);
      if (selectedDivision) {
        params.set(this.URL_PARAMS.DIVISION_DISPLAY_NAME, selectedDivision);
      } else {
        params.delete(this.URL_PARAMS.DIVISION_DISPLAY_NAME);
      }
      if (selectedDepartment) {
        params.set(this.URL_PARAMS.DEPARTMENT_DISPLAY_NAME, selectedDepartment);
      } else {
        params.delete(this.URL_PARAMS.DEPARTMENT_DISPLAY_NAME);
      }
      params.set(this.URL_PARAMS.COURSE_DISPLAY_NAME, selectedcourse);
      const hasCourseRefId = String(selectedcourseRefId || '')
        .split('|')
        .some(
          id =>
            id &&
            id !== 'null' &&
            id !== 'undefined'
        );
      if (hasCourseRefId) {
        params.set(this.URL_PARAMS.COURSE_REF_ID, selectedcourseRefId);
      } else if (hadCourseRefId || selectedCampus === 'courseRefId') {
        // Remaining filters no longer include this ref — drop it so restore
        // cannot resurrect a deleted course from a stale pipe list.
        params.delete(this.URL_PARAMS.COURSE_REF_ID);
      }
      params.set(this.URL_PARAMS.SECTION_DISPLAY_NAME, selectedsection);
      params.set(this.URL_PARAMS.TERM_ID, selectedTermId);
      this.syncStoreNumberQueryParam(params);

     
    } else {
      // Always skip stripping while restore is in flight — including student-id session
      // rehydration (typed id present, selectedFilters still empty), which previously cleared deep links.
      // User-initiated card remove must still strip so refresh/snapshot match the empty list.
      if (this.isUrlRestorePending() && !options?.forceEmptyStrip) {
        return;
      }
      [
        this.URL_PARAMS.DIVISION_DISPLAY_NAME,
        this.URL_PARAMS.DEPARTMENT_DISPLAY_NAME,
        this.URL_PARAMS.COURSE_DISPLAY_NAME,
        this.URL_PARAMS.COURSE_REF_ID,
        this.URL_PARAMS.SECTION_DISPLAY_NAME,
        this.URL_PARAMS.TERM_ID,
      ].forEach(param => params.delete(param));
      params.delete('bookstoreId');
      params.delete('merfnbr');
      // Keep `shopBy` so the current CMRP flow stays in the URL with no courses.
      const keepShopBy =
        params.get(this.URL_PARAMS.SHOP_BY) || this._preservedShopByFromUrl || '';
      if (keepShopBy) {
        params.set(this.URL_PARAMS.SHOP_BY, keepShopBy);
      } else if (typeof window.cmrpShopByParamForFlow === 'function') {
        const inferred = window.cmrpShopByParamForFlow(
          typeof window.cmrpCurrentFlow === 'function'
            ? window.cmrpCurrentFlow()
            : '',
        );
        if (inferred) params.set(this.URL_PARAMS.SHOP_BY, inferred);
      }
    }

    const qs = params
      .toString()
      .replaceAll('%2520', '%20')
      .replaceAll('%257C', '%7C')
      .replaceAll('%2526', '%26');
    const nextUrl = qs
      ? `${window.location.pathname}?${qs}`
      : window.location.pathname;
    window.history.replaceState({}, '', nextUrl);
    // Keep restoration snapshot in sync with the address bar.
    this.parseURLParameters(true);
    if (typeof window.anchorCmrpProductsPanel === 'function') {
      window.anchorCmrpProductsPanel();
    }
    // Session snapshot: remember last results URL when courses are present.
    // Do not clear on empty filters here — explicit clearAll / fresh-start own that
    // (avoids wiping the stored URL during init races), except user-initiated remove.
    if (window.CmrpSessionSnapshot && this.selectedFilters.length > 0) {
      window.CmrpSessionSnapshot.saveResultsUrl(
        `${window.location.pathname}${window.location.search}`
      );
      if (
        !isStudentIdUrl &&
        typeof window.setCmrpInitialFlowPreference === 'function'
      ) {
        window.setCmrpInitialFlowPreference('course-builder');
      }
    } else if (window.CmrpSessionSnapshot && options?.forceEmptyStrip) {
      window.CmrpSessionSnapshot.clearLastResultsUrl?.();
    }
  }

  // @ts-ignore
  setOrDeleteParam(params, key, value) {
    if (value) {
      params.set(key, value);
    } else {
      params.delete(key);
    }
  }

  // @ts-ignore
  async restoreFormStateFromURL(
    termsIds,
    divisions,
    departments,
    courses,
    courseRefIds,
    sections
  ) {
    this.clearExistingFilters();
    
    const {
      filters,
      campusInfo,
      campusInfos,
      termClosedInfo,
      lookupError,
      lookupErrorContext,
      lookupErrorContexts,
    } = await this.buildFiltersFromURLParams(
        termsIds,
        divisions,
        departments,
        courses,
        courseRefIds,
        sections
      );
    // Closed terms skip that line only; keep restoring other campuses.
    if (termClosedInfo && filters.length === 0) {
      this.showTermClosedError(termClosedInfo);
      this.urlParamsToRestore = null;
      return;
    }

    if (filters.length === 0) {
      this.urlParamsToRestore = null;
      if (lookupError === 'term' || lookupError === 'course') {
        this.showUrlParamNotFoundError(
          lookupError,
          lookupErrorContexts?.length ? lookupErrorContexts : lookupErrorContext
        );
        return;
      }
      this.showEmptyStateAndHideLoading();
      return;
    }

    // Show subtitle and SHOP NOW button since term is open
    this.showTermOpenElements();

    this.selectedFilters.push(...filters);
    filters.forEach(filter => this.addLabelCallback(filter));
    // Manual Add Course also calls addSelectedCourse (bubbles). URL restore only used
    // addLabel (#course-list) — rebuild visible course chips from restored filters.
    if (
      typeof window.courseMaterialsSidebar?.syncBubblesFromFilters === 'function'
    ) {
      window.courseMaterialsSidebar.syncBubblesFromFilters(this.selectedFilters);
    }

    const restoreUiResult = await this.restoreDropdownsAndUI(
      campusInfo,
      campusInfos,
      lookupErrorContexts
    );
    // Invalid deep-link lines stay in selectedFilters for error cards; keep the original URL.
    if (!restoreUiResult?.preserveOriginalUrl) {
      this.setURLSearchParams();
    }
  }

  clearExistingFilters() {
    this.selectedFilters.length = 0;
    ['course-list', 'filtered-products'].forEach(id => {
      const element = document.getElementById(id);
      if (element) element.innerHTML = '';
    });
  }

  async buildFiltersFromURLParams(
    // @ts-ignore
    termsIds,
    // @ts-ignore
    divisions,
    // @ts-ignore
    departments,
    // @ts-ignore
    courses,
    // @ts-ignore
    courseRefIds,
    // @ts-ignore
    sections
  ) {
    const filters = [];
    let campusInfo = null;
    /** @type {Map<string, { campus: string, term: string, campusEntity: any, termEntity: any }>} */
    const campusInfosByKey = new Map();
    let termClosedInfo = null;
    /** @type {'term' | 'course' | null} */
    let lookupError = null;
    /** @type {Record<string, string> | null} */
    let lookupErrorContext = null;
    /** @type {Record<string, string>[]} */
    let lookupErrorContexts = [];

    const rememberCampusInfo = (campusEntity, termEntity) => {
      if (!campusEntity || !termEntity) return;
      const key = `${String(campusEntity.campus_entity_id || '')}|${String(termEntity.term_id || '')}`;
      if (!key || key === '|' || campusInfosByKey.has(key)) return;
      const info = {
        campus: campusEntity.name,
        term: termEntity.name,
        campusEntity,
        termEntity,
      };
      campusInfosByKey.set(key, info);
      if (!campusInfo) campusInfo = info;
    };

    const captureLookupErrorContext = (kind, courseData, resolvedCampusInfo) => {
      const ctx = {
        kind,
        division: decodeCmrpLabel(courseData.division || ''),
        department: decodeCmrpLabel(courseData.department || ''),
        course: decodeCmrpLabel(courseData.course || ''),
        section: decodeCmrpLabel(courseData.section || ''),
        courseRefId: String(courseData.courseRefId || '').trim(),
        campus: resolvedCampusInfo?.campus || '',
        term: resolvedCampusInfo?.term || '',
        storeNumber: String(courseData.storeNumber || '').trim(),
      };

      if (!lookupError) lookupError = kind;
      if (!lookupErrorContext) lookupErrorContext = ctx;

      const hasDisplayableSection =
        (ctx.department && ctx.course && ctx.section) || !!ctx.courseRefId;
      if (hasDisplayableSection || ctx.campus || ctx.storeNumber) {
        lookupErrorContexts.push(ctx);
      }
    };

    const maxLength = Math.max(
      termsIds.length,
      divisions.length,
      departments.length,
      courses.length,
      courseRefIds.length,
      sections.length
    );

    const rawTermIds = Array.isArray(this.urlParamsToRestore?.rawTermIds)
      ? this.urlParamsToRestore.rawTermIds
      : [];

    /** @type {Array<{ lineIndex: number, termId: string, rawTermId: any, storeNumber: string, division: any, department: any, course: any, courseRefId: any, section: any }>} */
    const courseDatas = [];
    for (let i = 0; i < maxLength; i++) {
      courseDatas.push({
        lineIndex: i,
        termId: termsIds[i] || '',
        rawTermId:
          rawTermIds[i] ||
          (termsIds.length <= 1
            ? this.urlParamsToRestore?.rawTermId || ''
            : '') ||
          '',
        storeNumber: this.resolveStoreNumberForLine(i),
        division: divisions[i] || '',
        department: departments[i] || '',
        course: courses[i] || '',
        courseRefId: courseRefIds[i] || '',
        section: sections[i] || '',
      });
    }

    // Warm metaobject/product caches in parallel layers using the same query
    // strings the sequential restore path will reuse (identical results).
    await this.prefetchUrlRestoreLookups(courseDatas);

    for (let i = 0; i < courseDatas.length; i++) {
      const courseData = courseDatas[i];

      try {
        const hasFullCourseLine =
          courseData.department && courseData.course && courseData.section;
        const hasFullCourseRefLine = this.isUsableCourseRefId(
          courseData.courseRefId
        );
        // Skip filter building when no full course line, but still check term closed if we have termId
        if (!hasFullCourseLine && !hasFullCourseRefLine) {
          if (courseData.termId) {
            const entities = await this.findMatchingEntities(courseData);
            if (!entities) {
              captureLookupErrorContext('term', courseData, null);
            } else if (entities.termClosed === true) {
              const { campusEntity, termEntity } = entities;
              if (!termClosedInfo) {
                termClosedInfo = {
                  campus: campusEntity.name,
                  term: termEntity.name,
                  department: courseData.department || '',
                  course: courseData.course || '',
                  campusEntity,
                  termEntity,
                };
              }
            }
          }
          continue;
        }
        const entities = await this.findMatchingEntities(courseData);
        if (!entities) {
          // Unmatched termId → term; course/courseRef deep-link without a resolvable term → course
          const kind = String(courseData.termId || '').trim() ? 'term' : 'course';
          captureLookupErrorContext(kind, courseData, null);
          continue;
        }

        const { campusEntity, termEntity, termClosed } = entities;

        // Check if term is closed
        if (termClosed === true) {
          if (!termClosedInfo) {
            termClosedInfo = {
              campus: campusEntity.name,
              term: termEntity.name,
              department: courseData.department,
              course: courseData.course,
              campusEntity,
              termEntity,
            };
          }
          // Don't add filters for closed terms, but store the info
          continue;
        }

        rememberCampusInfo(campusEntity, termEntity);

        const fo = await this.createFilterObject(
          courseData,
          campusEntity,
          termEntity,
          hasFullCourseRefLine
        );
        if (fo) {
          filters.push(fo);
        } else {
          // Term resolved but courseRefId / course line did not match DDCS data.
          captureLookupErrorContext('course', courseData, {
            campus: campusEntity?.name || '',
            term: termEntity?.name || '',
          });
        }
      } catch (error) {
        console.error('Error restoring course line from URL:', error);
        captureLookupErrorContext('course', courseData, null);
      }
    }
    return {
      filters,
      campusInfo,
      campusInfos: Array.from(campusInfosByKey.values()),
      termClosedInfo,
      lookupError,
      lookupErrorContext,
      lookupErrorContexts,
    };
  }
  /**
   * @param {any} metaobjectType
   * @param {any} query
   */
  async fetchMetaobjects(metaobjectType, query) {
    if (typeof window !== 'undefined' && window.fetchMetaobjectsOnce) {
      return window.fetchMetaobjectsOnce(metaobjectType, query);
    }

    const proxyPath = '/apps/shopifyData/metaobjects';
    const url = `${proxyPath}?type=${metaobjectType}&query=${query}`;

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.success) {
        const activeMetaobjects = result.data.filter(
          item => item.status === 'ACTIVE',
        );
        return activeMetaobjects;
      } else {
        throw new Error(result.error || 'Failed to fetch metaobjects');
      }
    } catch (error) {
      console.error('Error fetching metaobjects:', error);
      throw error;
    }
  }
  /**
   * @param {any} queryData
   */
  async fetchProducts(queryData) {
    if (typeof window !== 'undefined' && window.fetchProductsOnce) {
      return window.fetchProductsOnce(queryData);
    }

    const proxyPath = '/apps/shopifyData/products';
    const url = `${proxyPath}?query=${queryData}`;

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.success) {
        return result.products;
      } else {
        throw new Error(result.error || 'Failed to fetch products');
      }
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  }
  /**
   * Fetch campus metaobject by campus_entity_id when not in config
   * @param {string} campusEntityId
   * @returns {Promise<object|null>} campus metaobject or null
   */
  async fetchCampusByEntityId(campusEntityId) {
    if (!campusEntityId) return null;
    const query = "fields.campus_entity_id:'" + campusEntityId + "'";
    const campuses = await this.fetchMetaobjects('ddcs_campus', query);
    return campuses && campuses.length > 0 ? campuses[0] : null;
  }

  /**
   * Same courseRefId guard used when building filters from the URL.
   * @param {any} value
   * @returns {boolean}
   */
  isUsableCourseRefId(value) {
    return Boolean(
      value &&
        value !== '' &&
        value !== null &&
        value !== undefined &&
        value !== 'null' &&
        value !== 'undefined'
    );
  }

  /**
   * @param {any[]} items
   * @param {(item: any, index: number) => Promise<any>} worker
   * @param {number} [concurrency]
   * @returns {Promise<any[]>}
   */
  async runWithConcurrency(items, worker, concurrency = 16) {
    const arr = Array.from(items || []);
    if (arr.length === 0) return [];
    const results = new Array(arr.length);
    let nextIndex = 0;
    const runnerCount = Math.min(Math.max(1, concurrency), arr.length);
    await Promise.all(
      Array.from({ length: runnerCount }, async () => {
        while (nextIndex < arr.length) {
          const i = nextIndex++;
          try {
            results[i] = await worker(arr[i], i);
          } catch (error) {
            results[i] = undefined;
          }
        }
      })
    );
    return results;
  }

  collectUniqueIds(values) {
    const seen = new Set();
    const out = [];
    for (let i = 0; i < (values?.length || 0); i++) {
      const value = values[i];
      if (value == null || value === '') continue;
      const id = String(value);
      if (seen.has(id)) continue;
      seen.add(id);
      out.push(id);
    }
    return out;
  }

  /**
   * Prefetch DDCS metaobjects (and product queries) for URL restore using the
   * exact same query strings as findMatchingEntities / findSectionByCourseRefId /
   * refreshProductsDisplay. fetchMetaobjectsOnce / fetchProductsOnce then serve
   * the sequential restore loop from cache — same results, far fewer round-trips.
   * @param {any[]} courseDatas
   */
  async prefetchUrlRestoreLookups(courseDatas) {
    if (!Array.isArray(courseDatas) || courseDatas.length === 0) return;

    const termTargets = [];
    const seenTermKeys = new Set();
    for (let i = 0; i < courseDatas.length; i++) {
      const courseData = courseDatas[i];
      const termIdTrim =
        courseData?.termId != null ? String(courseData.termId).trim() : '';
      if (!termIdTrim || termIdTrim.includes('|')) continue;
      const termKey = `${termIdTrim}|${courseData.rawTermId || ''}|${courseData.storeNumber || ''}`;
      if (seenTermKeys.has(termKey)) continue;
      seenTermKeys.add(termKey);
      termTargets.push(courseData);
    }

    const seenCampusTerm = new Set();
    const resolvedTermIds = new Set();
    await this.runWithConcurrency(termTargets, async courseData => {
      try {
        const entities = await this.findMatchingEntities(courseData);
        if (entities?.termEntity?.term_id && !entities.termClosed) {
          resolvedTermIds.add(String(entities.termEntity.term_id));
        }
        if (
          entities &&
          !entities.termClosed &&
          entities.termEntity?.term_id &&
          entities.termEntity?.campus_entity_id &&
          typeof window.fetchFilteredDataOnce === 'function'
        ) {
          const key = `${entities.termEntity.campus_entity_id}|${entities.termEntity.term_id}`;
          if (!seenCampusTerm.has(key)) {
            seenCampusTerm.add(key);
            window
              .fetchFilteredDataOnce(
                entities.termEntity.term_id,
                entities.termEntity.campus_entity_id
              )
              .catch(() => null);
          }
        }
        return entities;
      } catch (error) {
        return null;
      }
    });

    const courseRefIds = this.collectUniqueIds(
      courseDatas
        .filter(courseData => this.isUsableCourseRefId(courseData?.courseRefId))
        .map(courseData => courseData.courseRefId)
    );
    if (courseRefIds.length === 0 || resolvedTermIds.size === 0) return;

    const sectionQuery = id =>
      `fields.section_key:'${id}' fields.disabled_flag:false`;
    const courseQuery = id =>
      `fields.course_id:'${id}' fields.disabled_flag:false`;
    const departmentQuery = id =>
      `fields.campus_department_id:'${id}' fields.disabled_flag:false`;
    const divisionQuery = id =>
      `fields.campus_division_id:'${id}' fields.disabled_flag:false`;

    await this.runWithConcurrency(courseRefIds, async id => {
      try {
        return await this.fetchMetaobjects('ddcs_section', sectionQuery(id));
      } catch (error) {
        return [];
      }
    });

    const courseIds = [];
    const sectionGids = [];
    for (let i = 0; i < courseRefIds.length; i++) {
      let sections = [];
      try {
        sections = await this.fetchMetaobjects(
          'ddcs_section',
          sectionQuery(courseRefIds[i])
        );
      } catch (error) {
        sections = [];
      }
      if (!Array.isArray(sections)) continue;
      for (let s = 0; s < sections.length; s++) {
        const section = sections[s];
        const matchesTerm =
          resolvedTermIds.size === 0 ||
          (section?.term_id != null &&
            resolvedTermIds.has(String(section.term_id)));
        if (!matchesTerm) continue;
        if (section?.course_id) courseIds.push(section.course_id);
        if (section?.gid) sectionGids.push(section.gid);
      }
    }

    const uniqueCourseIds = this.collectUniqueIds(courseIds);
    const uniqueGids = this.collectUniqueIds(sectionGids);

    // Product fetches only need section GID; start them while course/dept/division resolve.
    if (typeof window.fetchProductsOnce === 'function') {
      for (let i = 0; i < uniqueGids.length; i++) {
        const queryDataProd =
          "metafields.ddcs.ddcs_section:'" + uniqueGids[i] + "'";
        window.fetchProductsOnce(queryDataProd).catch(() => []);
      }
    }

    await this.runWithConcurrency(uniqueCourseIds, async id => {
      try {
        return await this.fetchMetaobjects('ddcs_course', courseQuery(id));
      } catch (error) {
        return [];
      }
    });

    const departmentIds = [];
    for (let i = 0; i < uniqueCourseIds.length; i++) {
      let courses = [];
      try {
        courses = await this.fetchMetaobjects(
          'ddcs_course',
          courseQuery(uniqueCourseIds[i])
        );
      } catch (error) {
        courses = [];
      }
      if (!Array.isArray(courses)) continue;
      for (let c = 0; c < courses.length; c++) {
        if (courses[c]?.campus_department_id) {
          departmentIds.push(courses[c].campus_department_id);
        }
      }
    }

    const uniqueDepartmentIds = this.collectUniqueIds(departmentIds);
    await this.runWithConcurrency(uniqueDepartmentIds, async id => {
      try {
        return await this.fetchMetaobjects(
          'ddcs_department',
          departmentQuery(id)
        );
      } catch (error) {
        return [];
      }
    });

    const divisionIds = [];
    for (let i = 0; i < uniqueDepartmentIds.length; i++) {
      let departments = [];
      try {
        departments = await this.fetchMetaobjects(
          'ddcs_department',
          departmentQuery(uniqueDepartmentIds[i])
        );
      } catch (error) {
        departments = [];
      }
      if (!Array.isArray(departments)) continue;
      for (let d = 0; d < departments.length; d++) {
        if (departments[d]?.campus_division_id) {
          divisionIds.push(departments[d].campus_division_id);
        }
      }
    }

    const uniqueDivisionIds = this.collectUniqueIds(divisionIds);
    await this.runWithConcurrency(uniqueDivisionIds, async id => {
      try {
        return await this.fetchMetaobjects('ddcs_division', divisionQuery(id));
      } catch (error) {
        return [];
      }
    });
  }

  /**
   * @param {{ termId: any; rawTermId?: any; storeNumber?: any; lineIndex?: number; division?: any; department: any; course: any; section: any; }} courseData
   */
  async findMatchingEntities(courseData) {
    // First check if term exists (without is_term_open_flag filter to check its status)
    const lineIndex =
      Number.isFinite(courseData?.lineIndex) && courseData.lineIndex >= 0
        ? courseData.lineIndex
        : 0;
    // Prefer per-line store from courseData; fall back to positional URL resolve.
    // bookstoreId=0772|1395 pairs with termId=A|B by index.
    let storeNumber =
      courseData?.storeNumber != null
        ? String(courseData.storeNumber).trim()
        : '';
    if (!storeNumber || storeNumber.includes('|')) {
      storeNumber = this.resolveStoreNumberForLine(lineIndex);
    }

    const termIdTrim =
      courseData.termId != null ? String(courseData.termId).trim() : '';
    if (!termIdTrim || termIdTrim.includes('|')) {
      return false;
    }
    let rawTermId =
      courseData.rawTermId != null ? String(courseData.rawTermId).trim() : '';
    // Never query with a pipe-joined multi-term string; use the slot's termId only.
    if (!rawTermId || rawTermId.includes('|')) {
      const fromUrlParts = this.splitPipeUrlParam(
        new URLSearchParams(window.location.search).get(this.URL_PARAMS.TERM_ID),
      );
      if (fromUrlParts.length === 1) {
        rawTermId = fromUrlParts[0];
      } else if (fromUrlParts.length > 1) {
        rawTermId = fromUrlParts[lineIndex] || termIdTrim;
      } else if (rawTermId.includes('|')) {
        rawTermId = termIdTrim;
      }
    }
    const termIdFirstCap = termIdTrim
      ? termIdTrim.charAt(0).toUpperCase() + termIdTrim.slice(1)
      : '';
    const termIdVariants = [termIdTrim];

    if (rawTermId && rawTermId !== termIdTrim && !rawTermId.includes('|')) {
      termIdVariants.push(rawTermId);
    }
    if (termIdFirstCap && termIdFirstCap !== termIdTrim) {
      termIdVariants.push(termIdFirstCap);
    }
    
    const termOrClauses = termIdVariants.flatMap(id => [
      "fields.term:'" + id + "'",
      "fields.term_id:'" + id + "'",
    ]);

    let queryDataAll = 
    '(' + termOrClauses.join(' OR ') + ') ';

    if (storeNumber) {
      queryDataAll += " fields.store_number:'" + storeNumber + "'";
    }
    queryDataAll += ' fields.disabled_flag:false';
    queryDataAll += ' fields.is_term_open_flag:true';
    const allTerms = await this.fetchMetaobjects('ddcs_term', queryDataAll);
    
    
    
    if(allTerms && allTerms.length > 0){
      let termEntity = allTerms[0];
          
      let campusEntity = this.ddcsCampusEntity.find(
        // @ts-ignore
        c => c.campus_entity_id === termEntity.campus_entity_id
      );
      // Fallback: fetch campus from metaobjects API by campus_entity_id when not in config
      if (!campusEntity && termEntity.campus_entity_id) {
        campusEntity = await this.fetchCampusByEntityId(termEntity.campus_entity_id);
      }
      if (!campusEntity && termEntity.campus_entity_id) {
        campusEntity = {
          name: 'Campus',
          campus_entity_id: termEntity.campus_entity_id
        };
      }

      // Check if term is closed (explicitly false) or forced closed for testing
      const isTermClosed = termEntity.is_term_open_flag === false || termEntity.is_term_open_flag === 'false';
      
      if(isTermClosed) {
        return campusEntity && termEntity ? { campusEntity, termEntity, termClosed: true } : null;
      }

      return campusEntity && termEntity ? { campusEntity, termEntity, termClosed: false } : null;
    }

    return false;
    
  }

  // @ts-ignore
  async findSectionByCourseRefId(courseData, termEntity) {
    const courseRefId = courseData?.courseRefId;
    if (!courseRefId) return null;

    const queryDataAll = `fields.section_key:'${courseRefId}' fields.disabled_flag:false`;
    const allSections = await this.fetchMetaobjects(
      'ddcs_section',
      queryDataAll
    );
    if (allSections && allSections.length > 0) {
      const sectionEntity = termEntity?.term_id
      ? allSections?.find(section => section.term_id === termEntity.term_id)
      : allSections?.[0];
      if (!sectionEntity) return null;

      let sectionData = {};

      const courseEntity = await this.fetchMetaobjects(
        'ddcs_course',
        `fields.course_id:'${sectionEntity.course_id}' fields.disabled_flag:false`
      );
      if (courseEntity && courseEntity.length > 0) {
        const courseEntityData = courseEntity[0];
        sectionData.course = courseEntityData.coursenumber;

        const departmentEntity = await this.fetchMetaobjects(
          'ddcs_department',
          `fields.campus_department_id:'${courseEntityData.campus_department_id}' fields.disabled_flag:false`
        );
        if (departmentEntity && departmentEntity.length > 0) {
          const departmentEntityData = departmentEntity[0];
          sectionData.department = departmentEntityData.name;

          const divisionEntity = await this.fetchMetaobjects(
            'ddcs_division',
            `fields.campus_division_id:'${departmentEntityData.campus_division_id}' fields.disabled_flag:false`
          );
          if (divisionEntity && divisionEntity.length > 0) {
            const divisionEntityData = divisionEntity[0];
            sectionData.division = divisionEntityData.name;
          }
        }
      }

      sectionData.section_id = sectionEntity.section_id;
      sectionData.section = sectionEntity.name;
      sectionData.selectedsectionGid = sectionEntity.gid || '';
      sectionData.adoption_status =
        sectionEntity.adoption_status != null &&
        sectionEntity.adoption_status !== ''
          ? String(sectionEntity.adoption_status)
          : '';

      return sectionData;
    }

    return null;
  }

  /**
   * Attach selectedsectionGid / adoption_status onto URL-restored filters using
   * in-memory DDCS rows (same matching rules as ProductDisplayManager refresh).
   * Campus is resolved per filter so a parent+child deep link cannot inherit
   * the first campus's section GID (that duplicated 9941 materials onto 9942).
   * @param {Array<object>} filters
   * @param {string} [campusEntityId] fallback only when a filter has no campus
   */
  enrichFiltersWithSectionMeta(filters, campusEntityId) {
    if (!Array.isArray(filters) || !filters.length) return;

    const normalize = value =>
      String(value ?? '')
        .toLowerCase()
        .replace(/\s+/g, '')
        .replace(/%26/gi, '&')
        .replace(/&amp;/gi, '&');

    const fallbackCampusId = String(campusEntityId || '').trim();
    const departments = window.courseData?.ddcs_campus_department || [];
    const divisions = window.courseData?.ddcs_campus_division || [];
    const courses = window.courseData?.ddcs_course || [];
    const sections = window.courseData?.ddcs_section || [];

    filters.forEach(item => {
      if (!item || typeof item !== 'object') return;
      if (item._cmrpUrlNotFound) return;
      if (item.selectedsectionGid && item.hasOwnProperty('adoption_status')) {
        return;
      }

      let campusForItem = String(item.campus_entity_id || '').trim();
      if (!campusForItem && item.selectedCampus) {
        const campusMatch = (window.courseData?.ddcs_campus_entity || []).find(
          campus => normalize(campus.name) === normalize(item.selectedCampus)
        );
        campusForItem = campusMatch?.campus_entity_id || '';
      }
      if (!campusForItem && !item.selectedCampus && !item.store_number) {
        campusForItem = fallbackCampusId;
      }
      if (!campusForItem) return;

      let filteredDepartments = [];
      if (item.selectedDivision) {
        const filteredDivision = divisions.filter(
          division =>
            normalize(division.campus_entity_id) === normalize(campusForItem) &&
            (normalize(division.name) === normalize(item.selectedDivision) ||
              normalize(division.abbreviation) ===
                normalize(item.selectedDivision))
        );
        if (filteredDivision.length === 0) {
          filteredDepartments = departments.filter(
            department =>
              normalize(department.campus_entity_id) ===
                normalize(campusForItem) &&
              (normalize(department.name) ===
                normalize(item.selectedDepartment) ||
                normalize(department.abbreviation) ===
                  normalize(item.selectedDepartment) ||
                normalize(department.campus_department_id) ===
                  normalize(item.selectedDepartment))
          );
        } else {
          for (let div = 0; div < filteredDivision.length; div++) {
            filteredDepartments = departments.filter(
              department =>
                normalize(department.campus_entity_id) ===
                  normalize(campusForItem) &&
                normalize(department.campus_division_id) ===
                  normalize(filteredDivision[div].campus_division_id) &&
                (normalize(department.name) ===
                  normalize(item.selectedDepartment) ||
                  normalize(department.abbreviation) ===
                    normalize(item.selectedDepartment) ||
                  normalize(department.campus_department_id) ===
                    normalize(item.selectedDepartment))
            );
            if (filteredDepartments.length > 0) break;
          }
        }
      } else {
        filteredDepartments = departments.filter(
          department =>
            normalize(department.campus_entity_id) ===
              normalize(campusForItem) &&
            (normalize(department.name) === normalize(item.selectedDepartment) ||
              normalize(department.abbreviation) ===
                normalize(item.selectedDepartment) ||
              normalize(department.campus_department_id) ===
                normalize(item.selectedDepartment) ||
              normalize(department.department_id || '') ===
                normalize(item.selectedDepartment))
        );
      }

      let matchedSection = null;
      if (filteredDepartments.length > 0) {
        const filteredDepartment = filteredDepartments[0];
        const filteredCourse = courses.filter(
          course =>
            normalize(course.campus_entity_id) === normalize(campusForItem) &&
            normalize(course.campus_department_id) ===
              normalize(filteredDepartment.campus_department_id) &&
            normalize(course.coursenumber) === normalize(item.selectedcourse)
        );
        matchedSection =
          sections.find(
            section =>
              normalize(section.campus_entity_id) === normalize(campusForItem) &&
              filteredCourse[0] &&
              normalize(section.course_id) ===
                normalize(filteredCourse[0].course_id) &&
              (normalize(section.name) === normalize(item.selectedsection || '') ||
                normalize(section.section_id || '') ===
                  normalize(item.selectedsection || ''))
          ) || null;
      }

      if (!matchedSection) return;

      item.selectedsectionGid = matchedSection.gid || '';
      item.selectedsectionId = matchedSection.section_id || '';
      item.adoption_status =
        matchedSection.adoption_status != null &&
        matchedSection.adoption_status !== ''
          ? String(matchedSection.adoption_status)
          : '';
      item.instructor_first_name =
        matchedSection.instructor_first_name || item.instructor_first_name || '';
      item.instructor_last_name =
        matchedSection.instructor_last_name || item.instructor_last_name || '';
      if (matchedSection.name) {
        item.selectedsection = matchedSection.name;
      }
    });
  }

  // @ts-ignore
  async createFilterObject(
    courseData,
    campusEntity,
    termEntity,
    hasFullCourseRefLine
  ) {
    if (hasFullCourseRefLine) {
      const courseRefIdData = await this.findSectionByCourseRefId(courseData, termEntity);
      if (!courseRefIdData) return null;

      const base = {
        selectedDepartment: cmrpSafeDecodeURIComponent(
          courseRefIdData.department
        ),
        selectedCampus: cmrpSafeDecodeURIComponent(campusEntity.name),
        selectedTerm: cmrpSafeDecodeURIComponent(termEntity.name),
        selectedTermId: cmrpSafeDecodeURIComponent(termEntity.term_id),
        selectedcourse: cmrpSafeDecodeURIComponent(courseRefIdData.course),
        selectedsection: cmrpSafeDecodeURIComponent(
          courseRefIdData.section
        ),
        selectedsectionId: cmrpSafeDecodeURIComponent(
          courseRefIdData.section_id
        ),
        courseRefId: String(courseData.courseRefId || '').trim(),
        selectedDivision: cmrpSafeDecodeURIComponent(courseRefIdData.division),
        selectedsectionGid: courseRefIdData.selectedsectionGid || '',
        adoption_status: courseRefIdData.adoption_status || '',
        instructor_first_name: courseRefIdData.instructor_first_name || '',
        instructor_last_name: courseRefIdData.instructor_last_name || '',
        store_number: String(courseData.storeNumber || '').trim(),
        campus_entity_id: String(
          campusEntity.campus_entity_id || termEntity.campus_entity_id || ''
        ).trim(),
      };

      if (this._cmrpUrlRestoreTargetStudentIdForm) {
        // @ts-ignore — keeps course-builder chips empty (see syncBubblesFromFilters).
        base.fromStudentId = true;
      }

      return base;
    }

    const base = {
      selectedDepartment: cmrpSafeDecodeURIComponent(courseData.department),
      selectedCampus: cmrpSafeDecodeURIComponent(campusEntity.name),
      selectedTerm: cmrpSafeDecodeURIComponent(termEntity.name),
      selectedTermId: cmrpSafeDecodeURIComponent(termEntity.term_id),
      selectedcourse: cmrpSafeDecodeURIComponent(courseData.course),
      selectedsection: cmrpSafeDecodeURIComponent(courseData.section),
      selectedDivision: cmrpSafeDecodeURIComponent(courseData.division),
      store_number: String(courseData.storeNumber || '').trim(),
      campus_entity_id: String(
        campusEntity.campus_entity_id || termEntity.campus_entity_id || ''
      ).trim(),
    };

    if (this._cmrpUrlRestoreTargetStudentIdForm) {
      // @ts-ignore — keeps course-builder chips empty (see syncBubblesFromFilters).
      base.fromStudentId = true;
    }

    return base;
  }
  async fetchMetaobjectsData(termId, campusId) {
    // Usa helper global com cache quando disponível
    if (typeof window !== 'undefined' && window.fetchFilteredDataOnce) {
      return window.fetchFilteredDataOnce(termId, campusId);
    }

    // Fallback para implementação antiga (caso helper não esteja disponível)
    const proxyPath = '/apps/shopifyData/getFilteredData';
    const url = `${proxyPath}?campus_entity_id=${campusId}&term_id=${termId}`;

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.success) {
        return result.data;
      } else {
        throw new Error(result.error || 'Failed to fetch metaobjects');
      }
    } catch (error) {
      console.error('Error fetching metaobjects:', error);
      throw error;
    }
  }
  /**
   * Whether a URL-restored filter matches loaded DDCS rows.
   * Mirrors product-display-manager display-name resolution:
   * division (optional) → department → coursenumber → section name.
   * courseRefId restores already set `selectedsectionId`.
   * @param {any} filter
   * @returns {boolean}
   */
  urlRestoredFilterMatchesDdcs(filter) {
    if (!filter || filter._cmrpUrlNotFound) return false;

    const normalize = value =>
      String(decodeCmrpLabel(value ?? ''))
        .toLowerCase()
        .replace(/\s+/g, '');

    const sections = window.courseData?.ddcs_section || [];
    const courses = window.courseData?.ddcs_course || [];
    const departments = window.courseData?.ddcs_campus_department || [];
    const divisions = window.courseData?.ddcs_campus_division || [];

    if (filter.selectedsectionId) {
      const sectionId = normalize(filter.selectedsectionId);
      return sections.some(
        s =>
          normalize(s.section_id) === sectionId ||
          normalize(s.section_key) === sectionId
      );
    }

    const courseKey = normalize(filter.selectedcourse);
    const sectionKey = normalize(filter.selectedsection);
    const departmentKey = normalize(filter.selectedDepartment);
    const divisionKey = normalize(filter.selectedDivision);

    if (!courseKey || !sectionKey || !departmentKey) return false;

    let filteredDepartments = [];
    if (divisionKey) {
      const matchedDivisions = divisions.filter(
        d => normalize(d.name) === divisionKey
      );
      if (matchedDivisions.length === 0) {
        filteredDepartments = departments.filter(
          d =>
            normalize(d.name) === departmentKey ||
            normalize(d.campus_department_id) === departmentKey ||
            normalize(d.department_id || '') === departmentKey
        );
      } else {
        for (let i = 0; i < matchedDivisions.length; i++) {
          const div = matchedDivisions[i];
          filteredDepartments = departments.filter(
            d =>
              normalize(d.campus_division_id) ===
                normalize(div.campus_division_id) &&
              (normalize(d.name) === departmentKey ||
                normalize(d.campus_department_id) === departmentKey ||
                normalize(d.department_id || '') === departmentKey)
          );
          if (filteredDepartments.length > 0) break;
        }
      }
    } else {
      filteredDepartments = departments.filter(
        d =>
          normalize(d.name) === departmentKey ||
          normalize(d.campus_department_id) === departmentKey ||
          normalize(d.department_id || '') === departmentKey
      );
    }

    if (filteredDepartments.length === 0) return false;
    const department = filteredDepartments[0];

    const filteredCourse = courses.filter(
      c =>
        normalize(c.campus_department_id) ===
          normalize(department.campus_department_id) &&
        normalize(c.coursenumber) === courseKey
    );
    if (filteredCourse.length === 0) return false;

    return sections.some(
      s =>
        normalize(s.course_id) === normalize(filteredCourse[0].course_id) &&
        (normalize(s.name) === sectionKey ||
          normalize(s.section_id || '') === sectionKey)
    );
  }

  /**
   * Restore campus/term UI and refresh products after URL deep-link filters are built.
   * Loads DDCS for every unique campus+term in the deep link (not only the first),
   * so multi-campus restores can validate and render all course lines.
   * A course-not-found on one campus must not stop validation of the remaining campuses.
   * @param {any} campusInfo
   * @param {Array<{ campus: string, term: string, campusEntity: any, termEntity: any }>|null} [campusInfos]
   * @param {Record<string, string>[]|null} [lookupErrorContexts]
   * @returns {Promise<{ preserveOriginalUrl: boolean }>}
   */
  async restoreDropdownsAndUI(
    campusInfo,
    campusInfos = null,
    lookupErrorContexts = null
  ) {
    if (!campusInfo) {
      // @ts-ignore
      this.callIfExists(window.showEmptyState);
      return { preserveOriginalUrl: false };
    }

    /** Keep deep-link query as loaded when any course line fails DDCS match. */
    let preserveOriginalUrl = false;

    try {
      window.courseData.ddcs_campus_division = [];
      window.courseData.ddcs_campus_department = [];
      window.courseData.ddcs_course = [];
      window.courseData.ddcs_section = [];

      const infos =
        Array.isArray(campusInfos) && campusInfos.length > 0
          ? campusInfos
          : [campusInfo];

      // Multi campus/term: keep first campus|term in the top bar (beside Print List).
      // Later groups render their own inline headers; same-campus URLs stay normal.
      const campusTermBar = document.getElementById('campus-term-info');
      const campusTermDisplay = document.getElementById(
        'selected-campus-display',
      );
      const campusTermLeft = campusTermBar?.querySelector('.campus-term-left');
      if (campusTermBar) {
        campusTermBar.classList.toggle(
          'campus-term-bar--multi',
          infos.length > 1,
        );
        if (campusTermLeft) campusTermLeft.style.display = '';
      }
      if (campusTermDisplay && infos[0]?.campus && infos[0]?.term) {
        if (window.CourseMaterialsUtils?.setResultsCampusTermHeading) {
          CourseMaterialsUtils.setResultsCampusTermHeading(
            campusTermDisplay,
            infos[0].campus,
            infos[0].term,
            { forceCampus: infos.length > 1 },
          );
        } else {
          campusTermDisplay.textContent = window.CourseMaterialsUtils
            ? CourseMaterialsUtils.formatCampusTermTitle(
                infos[0].campus,
                infos[0].term,
                window.courseData?.ddcs_campus_entity,
              )
            : `${infos[0].campus} | ${infos[0].term}`;
        }
      }

      /** @type {any[]} */
      const mergedDivisions = [];
      /** @type {any[]} */
      const mergedDepartments = [];
      /** @type {any[]} */
      const mergedCourses = [];
      /** @type {any[]} */
      const mergedSections = [];

      await Promise.all(
        infos.map(async info => {
          try {
            const termId = info?.termEntity?.term_id;
            const campusId = info?.termEntity?.campus_entity_id;
            if (!termId || !campusId) return;
            const dataFilters = await this.fetchMetaobjectsData(termId, campusId);
            if (!dataFilters) return;
            if (Array.isArray(dataFilters.ddcs_campus_division)) {
              mergedDivisions.push(...dataFilters.ddcs_campus_division);
            }
            if (Array.isArray(dataFilters.ddcs_campus_department)) {
              mergedDepartments.push(...dataFilters.ddcs_campus_department);
            }
            if (Array.isArray(dataFilters.ddcs_course)) {
              mergedCourses.push(...dataFilters.ddcs_course);
            }
            if (Array.isArray(dataFilters.ddcs_section)) {
              mergedSections.push(...dataFilters.ddcs_section);
            }
          } catch (error) {
            console.error(
              'Error loading DDCS for campus/term during URL restore:',
              error
            );
          }
        })
      );

      window.courseData.ddcs_campus_division = mergedDivisions;
      window.courseData.ddcs_campus_department = mergedDepartments;
      window.courseData.ddcs_course = mergedCourses;
      window.courseData.ddcs_section = mergedSections;
      // Display-name deep links skip DDCS lookup in createFilterObject; verify against loaded rows.
      // Failed lines stay in selectedFilters so refresh can render their error cards and continue
      // other campuses — do not abort after the first "unable to find the specified course".
      if (Array.isArray(this.selectedFilters) && this.selectedFilters.length > 0) {
        const anyMissed = this.selectedFilters.some(
          filter => !this.urlRestoredFilterMatchesDdcs(filter)
        );
        if (anyMissed) {
          preserveOriginalUrl = true;
        }
      }

      // Do not stamp selectedsectionGid + adoption_status here. `dev` leaves
      // display-name deep links unresolved until refreshProductsDisplay's
      // section-first name match. Department-first enrich locked a GID fast path
      // that dropped most pipe-separated course lines.

      if (Array.isArray(lookupErrorContexts) && lookupErrorContexts.length > 0) {
        preserveOriginalUrl = true;
        for (const ctx of lookupErrorContexts) {
          if (!ctx) continue;
          const already = this.selectedFilters.some(f =>
            this.urlParamNotFoundContextMatchesFilter(ctx, f)
          );
          if (!already) {
            this.selectedFilters.push(this.filterFromUrlParamNotFoundContext(ctx));
          }
        }
      }

      this.setCampusDropdown(campusInfo.campus, campusInfo.campusEntity);
      await this.setTermDropdown(
        campusInfo.campus,
        campusInfo.term,
        campusInfo.termEntity
      );
      if (!this._cmrpUrlRestoreTargetStudentIdForm) {
        // Results restore via selectedFilters; keep Campus/Term but leave Course #1
        // DDCS fields empty for a fresh line (do not rehydrate Division→Section).
        this.urlParamsToRestore = null;
        this._isUrlFormCascadePending = false;
        // @ts-ignore
        window.courseMaterialsSidebar?.setupDivisionField?.();
        const primary =
          typeof window !== 'undefined'
            ? window.CmrpCourseRowManager?.getPrimaryRow?.()
            : null;
        if (
          primary &&
          typeof window.CmrpCourseRowManager?.clearRowFields === 'function'
        ) {
          window.CmrpCourseRowManager.clearRowFields(primary);
        } else {
          // @ts-ignore
          window.courseMaterialsSidebar?.clearDDCSSelections?.(true);
        }
      } else {
        this.urlParamsToRestore = null;
        this._isUrlFormCascadePending = false;
        if (
          typeof window !== 'undefined' &&
          typeof window.cmrpTruncateCmrpFilterSelectsIn === 'function'
        ) {
          window.cmrpTruncateCmrpFilterSelectsIn(
            document.getElementById('filters-section'),
          );
        }
      }

      // Campus/Term are set programmatically (no change event) — reveal Course #1.
      if (
        typeof window !== 'undefined' &&
        typeof window.CmrpCourseRowManager?.syncCourseRowsVisibility === 'function'
      ) {
        window.CmrpCourseRowManager.syncCourseRowsVisibility();
      }
      if (
        typeof window !== 'undefined' &&
        typeof window.cmrpCustomDropdowns?.syncAll === 'function'
      ) {
        window.cmrpCustomDropdowns.syncAll();
      }

      // Form cascade / change handlers may reload DDCS for the first campus only;
      // re-apply the multi-campus merge before product refresh.
      window.courseData.ddcs_campus_division = mergedDivisions;
      window.courseData.ddcs_campus_department = mergedDepartments;
      window.courseData.ddcs_course = mergedCourses;
      window.courseData.ddcs_section = mergedSections;

      const isCmrpResults =
        document.body?.classList?.contains('course-materials-page') === true;
      const isMobile = window.innerWidth < 968;
      // @ts-ignore
      if ((!isMobile || isCmrpResults) && window.courseMaterialsSidebar) {
        // @ts-ignore
        window.courseMaterialsSidebar.openSidePanel();
      }

      if (typeof window.anchorCmrpProductsPanel === 'function') {
        window.anchorCmrpProductsPanel();
      }

      const refreshOut = this.refreshProductsCallback(this.selectedFilters);
      if (refreshOut && typeof refreshOut.then === 'function') {
        await refreshOut;
      }

      if (typeof window.anchorCmrpProductsPanel === 'function') {
        window.anchorCmrpProductsPanel();
      }
      if (typeof window.syncCmrpProductsSectionShell === 'function') {
        window.syncCmrpProductsSectionShell();
      }
    } catch (error) {
      console.error('Error in restoreDropdownsAndUI:', error);
      // @ts-ignore
      this.callIfExists(window.hideLoadingState);
    }

    return { preserveOriginalUrl };
  }

  // @ts-ignore
  setCampusDropdown(campusName, campusEntity) {
    const campusSelect = this.cmrpUrlRestoreCampusTermSelect('campus');
    if (!campusSelect) return;

    // @ts-ignore
    campusSelect.value = campusName;

    if (typeof window !== 'undefined') {
      // @ts-ignore
      window.campus_entity_id = campusEntity.campus_entity_id;
      // @ts-ignore
      window.show_division =
        typeof window.cmrpResolveShowDivision === 'function'
          ? window.cmrpResolveShowDivision(campusEntity.is_division_used_flag)
          : campusEntity.is_division_used_flag;
    }

    // @ts-ignore
    if (window.courseMaterialsSidebar) {
      // @ts-ignore
      window.courseMaterialsSidebar.campus_entity_id =
        campusEntity.campus_entity_id;
      // @ts-ignore
      window.courseMaterialsSidebar.show_division =
        typeof window.cmrpResolveShowDivision === 'function'
          ? window.cmrpResolveShowDivision(campusEntity.is_division_used_flag)
          : campusEntity.is_division_used_flag;
    }
  }

  // @ts-ignore
  async setTermDropdown(campusName, termName, termEntity) {
    const termSelect = this.cmrpUrlRestoreCampusTermSelect('term');
    if (!termSelect) return;

    await this.populateTermsForCampus(campusName);
    // @ts-ignore
    //termSelect.value = termName;
    for (let i = 0; i < termSelect.options.length; i++) {
      termSelect.options[i].selected = false;
    }
    const options = termSelect.options;
    let matched = false;
    for (let i = 0; i < options.length; i++) {
      if (
        decodeCmrpLabel(cmrpOptionLabelForMatch(options[i])) ===
        decodeCmrpLabel(termName)
      ) {
        options[i].selected = true;
        matched = true;
        break;
      }
    }
    if (!matched && termEntity?.term_id) {
      const tid = String(termEntity.term_id);
      for (let i = 0; i < options.length; i++) {
        if (String(options[i].value) === tid) {
          options[i].selected = true;
          matched = true;
          break;
        }
      }
    }

    if (typeof window !== 'undefined') {
      // @ts-ignore
      window.term_id = termEntity.term_id;
    }

    // @ts-ignore
    if (window.courseMaterialsSidebar) {
      // @ts-ignore
      window.courseMaterialsSidebar.term_id = termEntity.term_id;
      // @ts-ignore
      window.courseMaterialsSidebar.checkCampusTermSelection();
    }

    if (!this._cmrpUrlRestoreTargetStudentIdForm) {
      this.triggerDepartmentCascadeForRestore();
    }

    if (
      typeof window !== 'undefined' &&
      typeof window.CmrpCourseRowManager?.syncCourseRowsVisibility === 'function'
    ) {
      window.CmrpCourseRowManager.syncCourseRowsVisibility();
    }
  }

  // @ts-ignore
  async populateTermsForCampus(campusName) {
    const termSelect = this.cmrpUrlRestoreCampusTermSelect('term');
    if (!termSelect) return;

    termSelect.innerHTML = '<option value="">Term</option>';

    const normalize = value =>
      String(value ?? '')
        .toLowerCase()
        .replace(/\s+/g, '');
    const campusPool =
      (typeof window !== 'undefined' &&
        Array.isArray(window.courseData?.ddcs_campus_entity) &&
        window.courseData.ddcs_campus_entity.length > 0 &&
        window.courseData.ddcs_campus_entity) ||
      this.ddcsCampusEntity ||
      [];
    const normLabel = value => normalize(decodeCmrpLabel(value));
    const campusKey = normLabel(String(campusName ?? '').trim());
    // @ts-ignore
    const campus = campusPool.find(c => normLabel(c.name) === campusKey);
    if (!campus) return;
    //const queryData = "fields.campus_entity_id:'"+campus.campus_entity_id+"' fields.disabled_flag:false fields.is_term_open_flag:true"
    const filteredTerms = window.courseData.ddcs_term.filter(
      term => normalize(term.campus_entity_id) === normalize(campus.campus_entity_id)
    );
    const sortValuesByName = (a, b) => {
      const nameA = decodeCmrpLabel(a.name);
      const nameB = decodeCmrpLabel(b.name);

      const isNumA = !isNaN(nameA.charAt(0));
      const isNumB = !isNaN(nameB.charAt(0));
      
      if (isNumA && isNumB) {
        return parseInt(nameA) - parseInt(nameB); 
      }
      
      if (isNumA) {
        return -1; 
      }
      
      if (isNumB) {
        return 1; 
      }
      
      return nameA.localeCompare(nameB, undefined, { sensitivity: 'base' });
    };
    const sortedValues = filteredTerms.sort(sortValuesByName);
    

    if (filteredTerms.length > 0) {
      // @ts-ignore
      termSelect.disabled = false;
      // @ts-ignore
      filteredTerms.forEach(term => {
        const option = document.createElement('option');
        option.value = term.term_id;
        if (
          typeof window !== 'undefined' &&
          typeof window.cmrpStampOptionFullLabel === 'function'
        ) {
          window.cmrpStampOptionFullLabel(option, decodeCmrpLabel(term.name));
        } else {
          option.textContent = decodeCmrpLabel(term.name);
        }
        termSelect.appendChild(option);
      });
    }
  }

  restoreAllFormFieldsFromURL() {
    
    // @ts-ignore
    if (!this.urlParamsToRestore || !window.courseMaterialsSidebar) return;
    
    const { divisions, departments, courses, sections } =
      this.urlParamsToRestore;
    const values = {
      division: cmrpSafeDecodeURIComponent(divisions[0]),
      department: cmrpSafeDecodeURIComponent(departments[0]),
      course: cmrpSafeDecodeURIComponent(courses[0]),
      section: cmrpSafeDecodeURIComponent(sections[0]),
    };
    this._isUrlFormCascadePending = true;
    setTimeout(() => this.restoreFieldsCascade(values), 100);
  }

  // @ts-ignore
  async restoreFieldsCascade(values) {
    // @ts-ignore
    const sidebar = window.courseMaterialsSidebar;
    const fields = {
      division: document.getElementById(cmrpCbCourseLineSelectId('division')),
      department: document.getElementById(cmrpCbCourseLineSelectId('department')),
      course: document.getElementById(cmrpCbCourseLineSelectId('course')),
      section: document.getElementById(cmrpCbCourseLineSelectId('section')),
    };

    const show_division =
      (typeof window.cmrpIsDivisionUsedGlobally === 'function'
        ? window.cmrpIsDivisionUsedGlobally()
        : true) && (window?.show_division || false);

    // Step 1: Division (if needed)
    if (values.division && show_division && fields.division) {
      await sidebar.populateDivision();
      setTimeout(async () => {
        if (fields.division){
          // @ts-ignore
          fields.division.value = values.division;
          // @ts-ignore
          const options = fields.division.options; 
          
          for (let i = 0; i < options.length; i++) {
              if (
                decodeCmrpLabel(cmrpOptionLabelForMatch(options[i])) ===
                decodeCmrpLabel(values.division)
              ) {
                  options[i].selected = true; 
                  break; 
              }
          }
        } 
        await this.continueWithDepartment(sidebar, fields, values);
      }, 50);
    } else {
      await this.continueWithDepartment(sidebar, fields, values);
    }
  }

  // @ts-ignore
  async continueWithDepartment(sidebar, fields, values) {
    // Step 2: Department
    await sidebar.populateDepartments();
    setTimeout(async () => {
      if (values.department && fields.department) {
        for (let i = 0; i < fields.department.options.length; i++) {
          fields.department.options[i].selected = false;
        }
        const options = fields.department.options;
        for (let i = 0; i < options.length; i++) {
          if (
            decodeCmrpLabel(cmrpOptionLabelForMatch(options[i])) ===
            decodeCmrpLabel(values.department)
          ) {
              options[i].selected = true; 
              break; 
          }
        }
      }
      await this.continueWithCourse(sidebar, fields, values);
    }, 50);
  }

  // @ts-ignore
  async continueWithCourse(sidebar, fields, values) {
    // Step 3: Course
    if (values.course && fields.course) {
      await sidebar.populateCourses();
      setTimeout(async () => {
        
        for (let i = 0; i < fields.course.options.length; i++) {
          fields.course.options[i].selected = false;
        }
        const options = fields.course.options;
        for (let i = 0; i < options.length; i++) {
          if (
            decodeCmrpLabel(cmrpOptionLabelForMatch(options[i])) ===
            decodeCmrpLabel(values.course)
          ) {
              options[i].selected = true; 
              break; 
          }
        }
        await this.continueWithSection(sidebar, fields, values);
      }, 50);
    } else {
      await this.finishRestore(sidebar);
    }
  }

  // @ts-ignore
  async continueWithSection(sidebar, fields, values) {
    // Step 4: Section
    if (values.section && fields.section) {
      await sidebar.populateSections();
      setTimeout(() => {
        for (let i = 0; i < fields.section.options.length; i++) {
          fields.section.options[i].selected = false;
        }
        const options = fields.section.options;
        for (let i = 0; i < options.length; i++) {
          if (
            decodeCmrpLabel(cmrpOptionLabelForMatch(options[i])) ===
            decodeCmrpLabel(values.section)
          ) {
              options[i].selected = true; 
              break; 
          }
        }
        this.finishRestore(sidebar);
      }, 50);
    } else {
      this.finishRestore(sidebar);
    }
  }

  // @ts-ignore
  async finishRestore(sidebar) {
    // Update button state after all fields are set
    //sidebar.updateAddCourseButtonState();
    this.urlParamsToRestore = null;
    this._isUrlFormCascadePending = false;
    if (
      typeof window !== 'undefined' &&
      typeof window.CmrpCourseRowManager?.syncCourseRowsVisibility === 'function'
    ) {
      window.CmrpCourseRowManager.syncCourseRowsVisibility();
    }
    if (
      typeof window !== 'undefined' &&
      typeof window.cmrpTruncateCmrpFilterSelectsIn === 'function'
    ) {
      window.cmrpTruncateCmrpFilterSelectsIn(
        document.getElementById('filters-section'),
      );
    }
    if (
      typeof window !== 'undefined' &&
      typeof window.cmrpCustomDropdowns?.syncAll === 'function'
    ) {
      window.cmrpCustomDropdowns.syncAll();
    }
  }

  triggerDepartmentCascadeForRestore() {
    const divisionFieldId =
      typeof window !== 'undefined' && typeof window.cmrpId === 'function'
        ? window.cmrpId('division_field', 'cb')
        : 'division_field';
    const divisionField = document.getElementById(divisionFieldId);
    const show_division =
      (typeof window.cmrpIsDivisionUsedGlobally === 'function'
        ? window.cmrpIsDivisionUsedGlobally()
        : true) && (window?.show_division || false);

    if (divisionField) {
      divisionField.hidden = !show_division;
      divisionField.style.display = show_division ? 'block' : 'none';
    }
  }
  async checkSession() {
    if (typeof window.cmrpGlobalCheckSession === 'function') {
      return window.cmrpGlobalCheckSession();
    }
    const token = sessionStorage.getItem('sessionToken');
    if (!token) return false;

    try {
      const response = await fetch('/apps/shopifyData/session/check', {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) throw new Error(`Error: ${response.status}`);

      return await response.json();
    } catch (error) {
      console.error('Error checking session:', error);
    }
  }
  async attemptURLRestoration() {
    // @ts-ignore
    if (!window.courseMaterialsSidebar) {
      this._urlRestoreSidebarRetries += 1;
      if (this._urlRestoreSidebarRetries > 50) {
        console.error(
          '[CMRP restore] courseMaterialsSidebar never became available; releasing loader'
        );
        this.releaseInitialLoadingHold();
        return;
      }
      setTimeout(() => this.attemptURLRestoration(), 100);
      return;
    }

    this._urlRestoreSidebarRetries = 0;

    if (
      typeof window.CmrpSessionSnapshot?.isExpiryPromptPending === 'function' &&
      window.CmrpSessionSnapshot.isExpiryPromptPending()
    ) {
      this._urlRestoreAwaitingExpiryKeep = true;
      this.releaseInitialLoadingHold();
      this.showEmptyStateAndHideLoading();
      return;
    }

    this._isUrlRestoreInProgress = true;
    const RESTORE_TIMEOUT_MS = 25000;
    const restoreWatchdog = setTimeout(() => {
      if (window.__cmrpHoldLoadingUntilResults !== true) return;
      console.error(
        `[CMRP restore] still in progress after ${RESTORE_TIMEOUT_MS}ms; releasing loader`
      );
      this.releaseInitialLoadingHold();
    }, RESTORE_TIMEOUT_MS);
    try {
      // Single-campus / single-term sidebar init calls clearAllUserSelections → setURLSearchParams,
      // which strips query params and re-parses an empty urlParamsToRestore before this runs.
      if (this._initialUrlRestoreSnapshot) {
        const snap = this._initialUrlRestoreSnapshot;
        const snapHas = [
          snap.termsIds,
          snap.divisions,
          snap.departments,
          snap.courses,
          snap.courseRefIds,
          snap.sections,
        ].some(arr => Array.isArray(arr) && arr.length > 0);
        if (snapHas) {
          this.urlParamsToRestore = {
            rawTermId: snap.rawTermId ?? null,
            rawTermIds: Array.isArray(snap.rawTermIds) ? [...snap.rawTermIds] : [],
            termsIds: [...snap.termsIds],
            divisions: [...snap.divisions],
            departments: [...snap.departments],
            courses: [...snap.courses],
            courseRefIds: [...snap.courseRefIds],
            sections: [...snap.sections],
          };
        }
      }

      if (!this.urlParamsToRestore) {
        this.showEmptyStateAndHideLoading();
        return;
      }

      const {
        termsIds,
        divisions,
        departments,
        courses,
        courseRefIds,
        sections,
      } = this.urlParamsToRestore;

      const hasCourseParams = [
        termsIds,
        divisions,
        departments,
        courses,
        courseRefIds,
        sections,
      ].some(arr => arr.length > 0);

      const forcedFlowPref =
        typeof window.readCmrpInitialFlowPreference === 'function'
          ? window.readCmrpInitialFlowPreference()
          : '';
      const courseRefDeepLink =
        Array.isArray(courseRefIds) && courseRefIds.length > 0;
      // DDCS shop-by-course deep links must restore into the course-builder panel,
      // even if a prior student-id session/token is still active.
      // Student-ID results URLs also carry the same course param payload — do not
      // treat those as course-builder deep links.
      const shopByFromUrl =
        (typeof window.cmrpReadShopByFromSearch === 'function'
          ? window.cmrpReadShopByFromSearch()
          : String(
              new URLSearchParams(window.location.search).get(
                this.URL_PARAMS.SHOP_BY,
              ) || '',
            ).trim().toLowerCase()) ||
        this._preservedShopByFromUrl ||
        '';
      const shopByMeansStudentId =
        typeof window.cmrpShopByIsStudentId === 'function'
          ? window.cmrpShopByIsStudentId(shopByFromUrl)
          : String(shopByFromUrl).trim().toLowerCase() === 'studentid' ||
            String(shopByFromUrl).trim().toLowerCase() === 'student-id';
      const shopByMeansCourseBuilder =
        typeof window.cmrpShopByMeansCourseUrl === 'function'
          ? window.cmrpShopByMeansCourseUrl(shopByFromUrl)
          : Boolean(String(shopByFromUrl).trim()) && !shopByMeansStudentId;
      const urlPrefersCourseBuilder =
        typeof window.cmrpUrlShouldRestoreAsCourseBuilder === 'function'
          ? window.cmrpUrlShouldRestoreAsCourseBuilder()
          : typeof window.cmrpUrlPrefersCourseBuilderDeepLink === 'function'
            ? window.cmrpUrlPrefersCourseBuilderDeepLink()
            : shopByMeansCourseBuilder || courseRefDeepLink;
      // Prefer student-id chrome when the URL says so. A leftover cmrp_initial_flow
      // must not override an explicit course / courseRefId / Discover deep link.
      const preferStudentIdForm =
        shopByMeansStudentId ||
        (forcedFlowPref === 'student-id' &&
          !shopByMeansCourseBuilder &&
          !urlPrefersCourseBuilder);
      const hasDdcsCourseParamPayload =
        (Array.isArray(departments) && departments.length > 0) ||
        (Array.isArray(courses) && courses.length > 0) ||
        (Array.isArray(sections) && sections.length > 0);
      const ddcsCourseDeepLink =
        !preferStudentIdForm &&
        (shopByMeansCourseBuilder ||
          urlPrefersCourseBuilder ||
          hasDdcsCourseParamPayload);
      const skipSessionForCourseRestore =
        !preferStudentIdForm &&
        (forcedFlowPref === 'course-builder' ||
          courseRefDeepLink ||
          ddcsCourseDeepLink ||
          shopByMeansCourseBuilder);

      const session_check = skipSessionForCourseRestore
        ? null
        : await this.checkSession();

      let resolvedStudentId = null;
      if (!skipSessionForCourseRestore) {
        if (session_check && session_check.status && session_check.sessionID) {
          resolvedStudentId = session_check.sessionID;
        } else if (typeof window.consumeCmrpStudentIdPrefill === 'function') {
          const pref = window.consumeCmrpStudentIdPrefill();
          resolvedStudentId = pref || null;
        } else {
          try {
            const k = 'cmrp_student_id_prefill';
            const raw = sessionStorage.getItem(k);
            if (raw) {
              sessionStorage.removeItem(k);
              resolvedStudentId = String(raw).trim() || null;
            }
          } catch (e) {
            /* ignore */
          }
        }
      }

      const resolveStudentIdUrlRestoreTarget = () => {
        if (preferStudentIdForm) {
          return true;
        }
        // Never dock DDCS course-builder restores under the hidden student-id form.
        if (ddcsCourseDeepLink || skipSessionForCourseRestore) {
          return false;
        }
        if (resolvedStudentId && hasCourseParams && !skipSessionForCourseRestore) {
          return true;
        }
        return Boolean(
          typeof window.cmrpResolveProductsAnchorUnderStudentForm ===
            'function' && window.cmrpResolveProductsAnchorUnderStudentForm(),
        );
      };

      if (resolvedStudentId) {
        this._cmrpUrlRestoreTargetStudentIdForm = resolveStudentIdUrlRestoreTarget();
        this.restoreStudentIdFromURL(resolvedStudentId, hasCourseParams);
        if (hasCourseParams) {
          await this.restoreFormStateFromURL(
            termsIds,
            divisions,
            departments,
            courses,
            courseRefIds,
            sections
          );
        }
        return;
      }

      if (hasCourseParams) {
        this._cmrpUrlRestoreTargetStudentIdForm = resolveStudentIdUrlRestoreTarget();
        if (this._cmrpUrlRestoreTargetStudentIdForm) {
          // Resume student-id results (e.g. session snapshot) without a live session token.
          if (typeof window.setCmrpInitialFlowPreference === 'function') {
            window.setCmrpInitialFlowPreference('student-id');
          }
          if (typeof window.cmrpPersistFlow === 'function') {
            window.cmrpPersistFlow('student-id');
          }
          if (
            window.courseMaterialsSidebar &&
            typeof window.courseMaterialsSidebar.enableStudentIdMode === 'function'
          ) {
            window.courseMaterialsSidebar.enableStudentIdMode();
          }
          if (
            window.courseMaterialsSidebar &&
            typeof window.courseMaterialsSidebar.openSidePanel === 'function'
          ) {
            window.courseMaterialsSidebar.openSidePanel();
          }
          this.hideCourseSelectionFields();
        } else if (
          window.courseMaterialsSidebar &&
          typeof window.courseMaterialsSidebar.disableStudentIdMode === 'function'
        ) {
          // Ensure course-builder chrome is visible so docked #products-section is not
          // under a display:none student-id form after a prior student-id session.
          if (typeof window.setCmrpInitialFlowPreference === 'function') {
            window.setCmrpInitialFlowPreference('course-builder');
          }
          if (typeof window.cmrpPersistFlow === 'function') {
            window.cmrpPersistFlow('course-builder');
          }
          window.courseMaterialsSidebar.disableStudentIdMode(true);
        }
        await this.restoreFormStateFromURL(
          termsIds,
          divisions,
          departments,
          courses,
          courseRefIds,
          sections
        );
      } else {
        this.showEmptyStateAndHideLoading();
      }
    } finally {
      clearTimeout(restoreWatchdog);
      this._cmrpUrlRestoreTargetStudentIdForm = false;
      this._initialUrlRestoreSnapshot = null;
      this._deferEmptyFilterUrlStrip = false;
      this._isUrlRestoreInProgress = false;
      // Keep _isUrlFormCascadePending until finishRestore (form cascade is async).
      this.releaseInitialLoadingHold();
    }
  }

  /**
   * Deep-link loads hold #loading-state across campus/term populate, DDCS
   * metaobject resolution, and product queries. Release only after restore
   * (including awaited refreshProductsCallback) has settled.
   */
  releaseInitialLoadingHold() {
    const wasHeld = window.__cmrpHoldLoadingUntilResults === true;
    window.__cmrpHoldLoadingUntilResults = false;
    if (!wasHeld) return;
    window.__cmrpPendingHideLoadingState = false;
    this.callIfExists(window.hideLoadingState);
  }

  // @ts-ignore
  restoreStudentIdFromURL(studentId, hasCourseParams = false) {
    const isCmrpResults =
      document.body?.classList?.contains('course-materials-page') === true;
    const isMobile = window.innerWidth < 968;

    // @ts-ignore
    if ((!isMobile || isCmrpResults) && window.courseMaterialsSidebar) {
      // @ts-ignore
      window.courseMaterialsSidebar.openSidePanel();
    }

    // Note: Mobile drawer opening is handled by course-materials-mobile.js
    // via its restoreStudentIdFromURL() method which opens the correct drawer

    this.expandSkipSection();

    const studentIdField = document.getElementById(
      typeof window.cmrpId === 'function'
        ? window.cmrpId('student-id', 'sid')
        : 'student-id',
    );
    if (studentIdField) {
      // @ts-ignore
      studentIdField.value = studentId;
    }

    const mobileStudentIdInput = document.getElementById('mobile-student-id-input');
    if (mobileStudentIdInput) {
      // @ts-ignore
      mobileStudentIdInput.value = studentId;
    }

    const campusSelect = this._cmrpUrlRestoreTargetStudentIdForm
      ? this.cmrpUrlRestoreCampusTermSelect('campus')
      : typeof window.cmrpQueryDesktopCampusTerm === 'function'
        ? window.cmrpQueryDesktopCampusTerm('campus')
        : document.querySelector('#campus-term-dropdowns #campus');
    // @ts-ignore
    if (campusSelect && window.courseMaterialsSidebar) {
      // When deep-linking courses with an active session, `populateCampus(false)` auto-runs
      // `populateTerms` on single-campus stores — that chains into `clearAllTermSelections` and
      // races `restoreFormStateFromURL` (filters cleared / URL stripped before restore finishes).
      // @ts-ignore
      window.courseMaterialsSidebar.populateCampus(
        hasCourseParams === true,
        this._cmrpUrlRestoreTargetStudentIdForm ? 'sid' : null,
      );
      // @ts-ignore
      campusSelect.disabled = false;
    }

    // Hide course selection fields when using Student ID
    this.hideCourseSelectionFields();

    if (!hasCourseParams) {
      this.showEmptyStateAndHideLoading();
    }
  }

  hideCourseSelectionFields() {
    if (
      document.getElementById('filters-section')?.dataset?.cmrpStudentIdActive ===
      'true'
    ) {
      return;
    }
    const courseLineFields = document.querySelectorAll(
      '.cmrp-filter-form--course-builder .cmrp-course-line-fields',
    );
    courseLineFields.forEach(el => {
      el.style.display = 'none';
    });

    // Also hide the "What's the course name?" title if it exists separately
    const courseTitles = document.querySelectorAll('h3, .section-title');
    courseTitles.forEach(title => {
      if (
        title.textContent &&
        title.textContent.includes("What's the course name")
      ) {
        // @ts-ignore
        title.style.display = 'none';
      }
    });
  }

  showCourseSelectionFields() {
    if (
      document.getElementById('filters-section')?.dataset?.cmrpStudentIdActive ===
      'true'
    ) {
      return;
    }
    document
      .querySelectorAll(
        '.cmrp-filter-form--course-builder .cmrp-course-line-fields',
      )
      .forEach(el => {
        el.style.display = '';
      });

    if (
      typeof window !== 'undefined' &&
      typeof window.CmrpCourseRowManager?.syncCourseRowsVisibility === 'function'
    ) {
      window.CmrpCourseRowManager.syncCourseRowsVisibility();
    }

    // Show the "What's the course name?" title
    const courseTitles = document.querySelectorAll('h3, .section-title');
    courseTitles.forEach(title => {
      if (
        title.textContent &&
        title.textContent.includes("What's the course name")
      ) {
        // @ts-ignore
        title.style.display = '';
      }
    });
  }

  openMobileDrawerWithRetry(retryCount = 0, maxRetries = 10) {
    if (window.innerWidth >= 968) return; // Not mobile

    // @ts-ignore
    if (window.courseMaterialsMobileDrawer) {
      // @ts-ignore
      window.courseMaterialsMobileDrawer.open();
      return;
    }

    // Retry if mobile drawer not ready yet
    if (retryCount < maxRetries) {
      setTimeout(() => {
        this.openMobileDrawerWithRetry(retryCount + 1, maxRetries);
      }, 200);
    }
  }

  expandSkipSection() {
    const skipOptions = document.querySelector('.skip-options');
    const chevronIcon = document.querySelector('.chevron-down-icon');

    if (skipOptions && chevronIcon) {
      // @ts-ignore
      skipOptions.style.display = 'block';
      // @ts-ignore
      chevronIcon.style.transform = 'rotate(0deg)';
    }
  }

  showEmptyStateAndHideLoading() {
    // @ts-ignore
    this.callIfExists(window.hideLoadingState);
    // @ts-ignore
    this.callIfExists(window.showEmptyState);
  }

  /**
   * Shared chrome cleanup when URL restore cannot show materials.
   */
  prepareResultsPanelForLookupError() {
    // @ts-ignore
    this.callIfExists(window.hideLoadingState);

    const initialPlaceholder = document.getElementById('initial-placeholder');
    if (initialPlaceholder) {
      initialPlaceholder.style.display = 'none';
    }

    const filteredProducts = document.getElementById('filtered-products');
    if (filteredProducts) {
      filteredProducts.innerHTML = '';
    }

    const desktopSubtitle = document.querySelector(
      '.header-card-discover .course-materials-subtitle'
    );
    // @ts-ignore
    if (desktopSubtitle) desktopSubtitle.style.display = 'none';

    const desktopShopNow = document.querySelector(
      '.header-card-discover .form-actions-inline-discover'
    );
    // @ts-ignore
    if (desktopShopNow) desktopShopNow.style.display = 'none';

    const mobileSubtitle = document.querySelector(
      '.mobile-course-trigger .mobile-main-subtitle'
    );
    // @ts-ignore
    if (mobileSubtitle) mobileSubtitle.style.display = 'none';

    const mobileShopNow = document.querySelector(
      '.mobile-course-trigger .form-actions-inline-discover'
    );
    // @ts-ignore
    if (mobileShopNow) mobileShopNow.style.display = 'none';
  }

  /**
   * Context for course deep-link not-found cards (display names from URL restore).
   * @param {any} failed
   * @param {{ campus?: string; term?: string } | null} [campusInfo]
   * @returns {Record<string, string>}
   */
  buildUrlParamNotFoundCourseContext(failed, campusInfo = null) {
    return {
      kind: failed?._urlParamNotFoundKind || 'course',
      division: decodeCmrpLabel(failed?.selectedDivision || ''),
      department: decodeCmrpLabel(failed?.selectedDepartment || ''),
      course: decodeCmrpLabel(failed?.selectedcourse || ''),
      section: decodeCmrpLabel(failed?.selectedsection || ''),
      courseRefId: String(failed?.selectedsectionId || '').trim(),
      campus: failed?.selectedCampus || campusInfo?.campus || '',
      term: failed?.selectedTerm || campusInfo?.term || '',
      storeNumber: String(failed?.store_number || '').trim(),
    };
  }

  /**
   * Synthetic filter so a URL line that never resolved still renders an error card.
   * @param {Record<string, string>} ctx
   * @returns {any}
   */
  filterFromUrlParamNotFoundContext(ctx) {
    return {
      selectedCampus: ctx?.campus || '',
      selectedTerm: ctx?.term || '',
      selectedDivision: ctx?.division || '',
      selectedDepartment: ctx?.department || '',
      selectedcourse: ctx?.course || '',
      selectedsection: ctx?.section || '',
      selectedsectionId: ctx?.courseRefId || '',
      store_number: ctx?.storeNumber || '',
      _cmrpUrlNotFound: true,
      _urlParamNotFoundKind: ctx?.kind || 'course',
    };
  }

  /**
   * @param {Record<string, string>} ctx
   * @param {any} filter
   * @returns {boolean}
   */
  urlParamNotFoundContextMatchesFilter(ctx, filter) {
    const n = value =>
      String(decodeCmrpLabel(value ?? ''))
        .toLowerCase()
        .replace(/\s+/g, '');
    return (
      n(filter?.selectedcourse) === n(ctx?.course) &&
      n(filter?.selectedsection) === n(ctx?.section) &&
      n(filter?.selectedDepartment) === n(ctx?.department) &&
      n(filter?.selectedCampus || filter?.store_number) ===
        n(ctx?.campus || ctx?.storeNumber)
    );
  }

  /**
   * @param {string} [kind]
   * @returns {string}
   */
  urlParamNotFoundMessage(kind) {
    return kind === 'term'
      ? 'Unable to find the requested Term.'
      : 'We are unable to find the specified course.';
  }

  /**
   * Invalid deep-link URL param (termId / courseRefId / course line).
   * Renders the regular results course-card layout with the gray no-materials
   * status banner (same chrome as empty materials), instead of the course-builder
   * warning-message component.
   * For term errors, `context` may be an array — one card per URL section.
   * @param {'term' | 'course'} [kind='term']
   * @param {Record<string, string> | Record<string, string>[] | null} [context]
   */
  showUrlParamNotFoundError(kind = 'term', context = null) {
    this.prepareResultsPanelForLookupError();
    // @ts-ignore
    this.callIfExists(window.hideEmptyState);

    // Keep this off the course-builder warning-message chrome; clear if previously shown.
    // @ts-ignore
    const page = window.courseMaterialsPageInstance;
    if (page && typeof page.hideErrorMessage === 'function') {
      page.hideErrorMessage();
    }

    /** @type {(Record<string, string> | null)[]} */
    const contexts = Array.isArray(context)
      ? context
      : context
        ? [context]
        : [null];
    const primaryContext = contexts[0] || null;

    const campusLabelForNotFoundCtx = ctx => {
      // Term lookup failed: campus is unknown. Never use bookstoreId / store
      // number as a heading (e.g. "9942").
      return String(ctx?.campus || '').trim();
    };
    const groupKey = ctx =>
      `${campusLabelForNotFoundCtx(ctx).toLowerCase()}||${String(ctx?.term || '').trim().toLowerCase()}`;
    /** @type {{ key: string, campus: string, term: string, items: (Record<string, string> | null)[] }[]} */
    const groups = [];
    const groupMap = new Map();
    for (const ctx of contexts) {
      const key = groupKey(ctx);
      if (!groupMap.has(key)) {
        const group = {
          key,
          campus: campusLabelForNotFoundCtx(ctx),
          term: String(ctx?.term || '').trim(),
          items: [],
        };
        groupMap.set(key, group);
        groups.push(group);
      }
      groupMap.get(key).items.push(ctx);
    }

    const multiCampus = groups.length > 1 && groups.some(g => g.campus);

    // Only show the top campus|term bar when a real campus name resolved.
    const showCampusTermHeader = Boolean(
      groups.find(g => g.campus)?.campus &&
        (kind !== 'term' || groups.some(g => g.campus && g.term)),
    );
    const headerGroup = groups.find(g => g.campus) || groups[0];
    const campus = showCampusTermHeader
      ? String(headerGroup?.campus || '').trim()
      : '';
    const term = showCampusTermHeader
      ? String(headerGroup?.term || primaryContext?.term || '').trim()
      : '';

    const campusTermBar = document.getElementById('campus-term-info');
    const campusTermDisplay = document.getElementById('selected-campus-display');
    if (campusTermBar && campusTermDisplay) {
      if (campus && term) {
        if (window.CourseMaterialsUtils?.setResultsCampusTermHeading) {
          CourseMaterialsUtils.setResultsCampusTermHeading(
            campusTermDisplay,
            campus,
            term,
            { forceCampus: multiCampus },
          );
        } else {
          campusTermDisplay.textContent = window.CourseMaterialsUtils
            ? CourseMaterialsUtils.formatCampusTermTitle(campus, term, window.courseData?.ddcs_campus_entity)
            : `${campus} | ${term}`;
        }
        campusTermBar.style.display = 'flex';
        campusTermBar.classList.toggle('campus-term-bar--multi', multiCampus);
      } else {
        if (window.CourseMaterialsUtils?.clearCampusTermHeading) {
          CourseMaterialsUtils.clearCampusTermHeading(campusTermDisplay);
        } else {
          campusTermDisplay.textContent = '';
        }
        campusTermBar.style.display = 'none';
        campusTermBar.classList.remove('campus-term-bar--multi');
      }
    }

    const productsContainer = document.getElementById('filtered-products');
    if (productsContainer) {
      productsContainer.innerHTML = '';
      productsContainer.classList.toggle('has-multi-campus-groups', multiCampus);
    }

    const displayManager =
      window.courseMaterialsPageInstance?.components?.displayManager;
    let cardIndex = 0;
    let wrappedIndex = 0;
    groups.forEach(group => {
      let parent = productsContainer;
      const useCampusWrap = Boolean(
        multiCampus &&
          group.campus &&
          displayManager &&
          typeof displayManager.createCampusMaterialsGroup === 'function' &&
          productsContainer
      );
      if (useCampusWrap) {
        const { wrap, body } = displayManager.createCampusMaterialsGroup(
          {
            selectedCampus: group.campus,
            selectedTerm: group.term,
          },
          { isPrimary: wrappedIndex === 0 }
        );
        productsContainer.appendChild(wrap);
        parent = body;
        wrappedIndex += 1;
      }
      group.items.forEach(ctx => {
        const cardMessage = this.urlParamNotFoundMessage(ctx?.kind || kind);
        this.renderUrlParamNotFoundCourseCard(cardMessage, ctx, {
          append: cardIndex > 0 || Boolean(parent && parent !== productsContainer),
          parent,
        });
        cardIndex += 1;
      });
    });

    const isCmrpResults =
      document.body?.classList?.contains('course-materials-page') === true;
    const isMobile = window.innerWidth < 968;
    // @ts-ignore
    if ((!isMobile || isCmrpResults) && window.courseMaterialsSidebar) {
      // @ts-ignore
      window.courseMaterialsSidebar.openSidePanel();
    }

    if (typeof window.syncCmrpProductsSectionShell === 'function') {
      window.syncCmrpProductsSectionShell();
    }
  }

  /**
   * Build a regular course card into `#filtered-products` with the gray
   * `.adoption-message-content` banner used for courses with no materials.
   * URL display-name values compose the header even when DDCS did not match.
   * @param {string} message
   * @param {Record<string, string> | null} [context]
   * @param {{ append?: boolean, parent?: HTMLElement | null }} [options]
   */
  renderUrlParamNotFoundCourseCard(message, context = null, options = {}) {
    const productsContainer = document.getElementById('filtered-products');
    const appendTarget = options?.parent || productsContainer;
    if (!appendTarget) return;

    const append = options?.append === true || Boolean(options?.parent);
    if (!append && productsContainer) {
      productsContainer.innerHTML = '';
    }
    if (productsContainer) {
      productsContainer.classList.add('course-layout');
    }

    const department = String(context?.department || '').trim();
    const course = String(context?.course || '').trim();
    const section = String(context?.section || '').trim();
    const division = String(context?.division || '').trim();
    const courseRefId = String(context?.courseRefId || '').trim();

    const courseTitle =
      department || course
        ? `${department} ${course}`.trim()
        : courseRefId || 'Course';
    const sectionLabel = section || (courseRefId ? courseRefId : '—');

    const ADOPTION_STATUS_ICON =
      window.courseMaterialsPageInstance?.components?.displayManager
        ?.ADOPTION_STATUS_ICON ||
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/><path d="M12 8v4M12 16h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    const courseSection = document.createElement('div');
    courseSection.className = 'course-section';
    courseSection.dataset.departmentFilter = department.toLowerCase().trim();
    courseSection.dataset.campus = String(context?.campus || '').trim();
    courseSection.dataset.urlParamNotFound = 'true';

    const courseCard = document.createElement('div');
    courseCard.className = 'course-card';
    courseCard.dataset.division = division;
    courseCard.dataset.department = department;
    courseCard.dataset.course = course;
    courseCard.dataset.section = section;
    courseCard.dataset.urlParamNotFound = 'true';

    const headerSection = document.createElement('div');
    headerSection.className = 'course-header';

    const headerContent = document.createElement('div');
    headerContent.className = 'header-content';

    const courseDetails = document.createElement('div');
    courseDetails.className = 'course-details';

    const titleEl = document.createElement('div');
    titleEl.className = 'course-title';
    titleEl.textContent = courseTitle;

    const requiredEl = document.createElement('div');
    requiredEl.className = 'required-count';
    requiredEl.textContent = '0 required materials';

    const sectionEl = document.createElement('div');
    sectionEl.className = 'section-info';
    sectionEl.textContent = `Section: ${sectionLabel} | Instructor: TBA`;

    courseDetails.appendChild(titleEl);
    courseDetails.appendChild(requiredEl);
    courseDetails.appendChild(sectionEl);

    const headerActions = document.createElement('div');
    headerActions.className = 'header-actions';

    const removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'remove-btn';
    removeBtn.setAttribute('aria-label', 'Remove course');
    removeBtn.dataset.division = division;
    removeBtn.dataset.department = department;
    removeBtn.dataset.course = course;
    removeBtn.dataset.section = section;
    removeBtn.innerHTML = `
      Remove
      <svg class="remove-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false">
        <path d="M13.5 4.5L4.5 13.5M4.5 4.5L13.5 13.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
    removeBtn.addEventListener('click', () => {
      if (typeof window.removeCourse === 'function') {
        window.removeCourse(removeBtn);
        return;
      }
      courseSection.remove();
      if (productsContainer && productsContainer.children.length === 0) {
        productsContainer.classList.remove('course-layout');
        const campusTermBar = document.getElementById('campus-term-info');
        const campusTermDisplay = document.getElementById('selected-campus-display');
        if (campusTermDisplay) {
          if (window.CourseMaterialsUtils?.clearCampusTermHeading) {
            CourseMaterialsUtils.clearCampusTermHeading(campusTermDisplay);
          } else {
            campusTermDisplay.textContent = '';
          }
        }
        if (campusTermBar) campusTermBar.style.display = 'none';
        // @ts-ignore
        this.callIfExists(window.showEmptyState);
      }
      if (typeof window.syncCmrpProductsSectionShell === 'function') {
        window.syncCmrpProductsSectionShell();
      }
    });
    headerActions.appendChild(removeBtn);

    headerContent.appendChild(courseDetails);
    headerContent.appendChild(headerActions);
    headerSection.appendChild(headerContent);
    courseCard.appendChild(headerSection);

    const materialsSection = document.createElement('div');
    materialsSection.className = 'materials-section';

    const adoptionStyle = document.createElement('div');
    adoptionStyle.className = 'no-materials-message';
    adoptionStyle.innerHTML = `
      <div class="adoption-message-content">
        <div class="adoption-icon">${ADOPTION_STATUS_ICON}</div>
        <div class="adoption-text">
          <h4 class="adoption-title">Course Materials Status</h4>
          <p class="adoption-note"></p>
        </div>
      </div>
    `;
    const noteEl = adoptionStyle.querySelector('.adoption-note');
    if (noteEl) {
      noteEl.textContent = message;
    }
    materialsSection.appendChild(adoptionStyle);
    courseCard.appendChild(materialsSection);

    courseSection.appendChild(courseCard);
    appendTarget.appendChild(courseSection);

    document.dispatchEvent(new CustomEvent('materialsLoaded'));
    document.dispatchEvent(new CustomEvent('product-display:updated'));
  }

  /**
   * Show term closed error message
   * @param {{ campus: string; term: string; campusEntity: any; termEntity: any; }} termClosedInfo
   */
  showTermClosedError(termClosedInfo) {
    this.prepareResultsPanelForLookupError();
    
    // Show campus-term bar when campus and term names are present (enough to render the component)
    const campusTermBar = document.getElementById('campus-term-info');
    const campusTermDisplay = document.getElementById('selected-campus-display');
    if (campusTermBar && campusTermDisplay && termClosedInfo.campus && termClosedInfo.term) {
      if (window.CourseMaterialsUtils?.renderCampusTermHeading) {
        CourseMaterialsUtils.renderCampusTermHeading(campusTermDisplay, {
          campus: termClosedInfo.campus,
          term: termClosedInfo.term,
          campusEntities: window.courseData?.ddcs_campus_entity,
        });
      } else {
        campusTermDisplay.textContent = `${termClosedInfo.campus} | ${termClosedInfo.term}`;
      }
      campusTermBar.style.display = 'flex';
    }
    
    // Show term closed error message
    const noProductsFound = document.getElementById('no-products-found');
    if (noProductsFound) {
      const courseCodeElement = document.getElementById('term-closed-course-code');
      const courseCodeContainer = document.querySelector(
        '.term-closed-course-code-container'
      );
      const termClosedMessage = document.getElementById('term-closed-message');
      const termClosedText = termClosedMessage?.querySelector('.term-closed-text');

      if (courseCodeContainer) {
        // @ts-ignore
        courseCodeContainer.style.display = '';
      }
      
      // Update the course code if available (e.g., "COM 100")
      // @ts-ignore
      if (courseCodeElement && termClosedInfo.department && termClosedInfo.course) {
        // @ts-ignore
        courseCodeElement.textContent = `${termClosedInfo.department} ${termClosedInfo.course}`;
      }

      if (termClosedText) {
        termClosedText.textContent =
          "Oops, looks like we're not able to find this term's materials. Try a different term or check back later.";
      }
      
      if (termClosedMessage) {
        termClosedMessage.style.display = 'block';
      }
      
      noProductsFound.style.display = 'block';
    }
  }

  /**
   * Show subtitle and SHOP NOW button when term is open
   */
  showTermOpenElements() {
    // Show subtitle and SHOP NOW button in header (desktop)
    const desktopSubtitle = document.querySelector('.header-card-discover .course-materials-subtitle');
    // @ts-ignore
    if (desktopSubtitle) desktopSubtitle.style.display = 'block';
    
    const desktopShopNow = document.querySelector('.header-card-discover .form-actions-inline-discover');
    // @ts-ignore
    if (desktopShopNow) desktopShopNow.style.display = 'flex';
    
    // Show subtitle and SHOP NOW button in header (mobile)
    const mobileSubtitle = document.querySelector('.mobile-course-trigger .mobile-main-subtitle');
    // @ts-ignore
    if (mobileSubtitle) mobileSubtitle.style.display = 'block';
    
    const mobileShopNow = document.querySelector('.mobile-course-trigger .form-actions-inline-discover');
    // @ts-ignore
    if (mobileShopNow) mobileShopNow.style.display = 'flex';
  }

  // @ts-ignore
  callIfExists(fn) {
    if (typeof fn === 'function') {
      fn();
    }
  }

  initialize() {
    // Show loading only when there are URL params to restore
    // Re-attempt session URL restore in case head/init timing missed it
    if (typeof window.CmrpSessionSnapshot?.tryRestoreResultsUrl === 'function') {
      window.CmrpSessionSnapshot.tryRestoreResultsUrl();
    }

    if (
      typeof window.CmrpSessionSnapshot?.isExpiryPromptPending === 'function' &&
      window.CmrpSessionSnapshot.isExpiryPromptPending()
    ) {
      this._urlRestoreAwaitingExpiryKeep = true;
      return;
    }
    if (
      typeof window.CmrpSessionSnapshot?.shouldHaltUrlRestoreForExpiryPrompt ===
        'function' &&
      window.CmrpSessionSnapshot.shouldHaltUrlRestoreForExpiryPrompt()
    ) {
      this._urlRestoreAwaitingExpiryKeep = true;
      return;
    }

    this.startUrlRestoreFromCurrentParams();
  }

  /**
   * After the inactivity modal Keep, inject has already run — parse the
   * (possibly updated) address bar and start the normal URL restore.
   */
  resumeRestoreAfterExpiryKeep() {
    this._urlRestoreAwaitingExpiryKeep = false;
    this._restoreFromLocationStarted = false;
    this.startUrlRestoreFromCurrentParams();
  }

  startUrlRestoreFromCurrentParams() {
    if (this._restoreFromLocationStarted) return;
    this._restoreFromLocationStarted = true;
    this._urlRestoreAwaitingExpiryKeep = false;

    const {
      rawTermId,
      rawTermIds,
      termsIds,
      divisions,
      departments,
      courses,
      courseRefIds,
      sections,
    } = this.parseURLParameters(true);
    const hasURLParamsToRestore = [
      termsIds,
      divisions,
      departments,
      courses,
      courseRefIds,
      sections,
    ].some(arr => arr.length > 0);

    if (hasURLParamsToRestore) {
      this._initialUrlRestoreSnapshot = {
        rawTermId: rawTermId ?? null,
        rawTermIds: Array.isArray(rawTermIds) ? [...rawTermIds] : [],
        termsIds: [...termsIds],
        divisions: [...divisions],
        departments: [...departments],
        courses: [...courses],
        courseRefIds: [...courseRefIds],
        sections: [...sections],
      };
      this._deferEmptyFilterUrlStrip = true;
    } else {
      this._initialUrlRestoreSnapshot = null;
      this._deferEmptyFilterUrlStrip = false;
    }

    const shouldSkipInitialLoading = window.__skipInitialCourseLoading === true;
    if (hasURLParamsToRestore && !shouldSkipInitialLoading) {
      window.__cmrpHoldLoadingUntilResults = true;
      this.callIfExists(window.showLoadingState);
    }

    const scheduleAttempt = () =>
      setTimeout(() => this.attemptURLRestoration(), 300);

    // Do not restore URL-driven UI until campus/term lists exist (same timing as populateCampus).
    if (window.__cmrpCampusTermFetchApplied === true) {
      scheduleAttempt();
    } else {
      document.addEventListener('cmrp:campusTermDataReady', scheduleAttempt, {
        once: true,
      });
    }
  }

  // @ts-ignore
  updateSelectedFilters(newSelectedFilters) {
    this.selectedFilters = newSelectedFilters;
  }

  getCurrentURLParams() {
    return this.parseURLParameters(false);
  }

  // @ts-ignore
  setCallbacks(callbacks) {
    if (callbacks.addLabel) this.addLabelCallback = callbacks.addLabel;
    if (callbacks.refreshProducts)
      this.refreshProductsCallback = callbacks.refreshProducts;
  }

  // @ts-ignore
  updateStudentIdInURL(studentId) {
    const params = new URLSearchParams(window.location.search);
    

    const newUrl = params.toString()
      ? `${window.location.pathname}?${params}`
      : window.location.pathname;

    window.history.replaceState({}, '', newUrl);
  }

  clearURLState() {
    //this.clearURL();
    this.clearExistingFilters();
    this.urlParamsToRestore = null;
    this._initialUrlRestoreSnapshot = null;
    this._deferEmptyFilterUrlStrip = false;
    this._isUrlRestoreInProgress = false;
    this._preservedShopByFromUrl = '';
  }
}

// @ts-ignore
window.URLStateManager = URLStateManager;

// @ts-ignore
if (!window.CourseMatSystem) {
  // @ts-ignore
  window.CourseMatSystem = {};
}
// @ts-ignore
window.CourseMatSystem.URLStateManager = URLStateManager;
